import { extendGettingStartedTranslations } from "../../content/gettingStarted";
const messages = {
  pt: {
    translations: {
      gettingStarted: {
        hello: "Damos-lhe as boas-vindas, {{name}}",
        title: "Primeiros passos",
        subtitle: "Complete o básico para começar a atender.",
        next: "Seguinte:",
        completed: "{{done}} / {{total}} concluídos",
        allDone: "Pronto: a configuração inicial está completa.",
        steps: {
          connection: {
            title: "Criar a primeira conexão",
            desc: "Ligue um canal para começar a receber chats.",
            time: "2 min",
          },
          greeting: {
            title: "Personalizar a mensagem de saudação",
            desc: "Defina a primeira mensagem que os clientes recebem.",
            time: "1 min",
          },
          queue: {
            title: "Criar um departamento",
            desc: "Crie departamentos para organizar o atendimento.",
            time: "1 min",
          },
          invite: {
            title: "Convidar pessoas",
            desc: "Convide utilizadores e administradores para a empresa.",
            time: "1 min",
          },
          assignment: {
            title: "Definir atribuição automática",
            desc: "Associe departamentos à sua conexão WhatsApp.",
            time: "30s",
          },
        },
        extrasTitle: "Liberte o potencial da operação",
        extrasSubtitle: "Outras ferramentas para a equipa atender melhor.",
        extras: {
          new: "Novo",
          quick: {
            title: "Respostas rápidas",
            desc: "Mensagens prontas, ativadas com \"/\" no chat.",
          },
          tags: {
            title: "Etiquetas",
            desc: "Organize contactos e motivos de atendimento.",
          },
          kanban: {
            title: "Kanban",
            desc: "Veja o funil de atendimento por colunas.",
          },
          ai: {
            title: "Agentes IA",
            desc: "A sua base de conhecimento vira atendimento automático.",
          },
          campaigns: {
            title: "Campanhas",
            desc: "Envie mensagens em massa para listas de contactos.",
          },
          schedules: {
            title: "Mensagens programadas",
            desc: "Agende envios individuais para mais tarde.",
          },
          chat: {
            title: "Chat interno",
            desc: "Coordene a equipa sem sair do Watoolx.",
          },
          agenda: {
            title: "Agenda",
            desc: "Marcações, lembretes e acompanhamento.",
          },
          roles: {
            title: "Equipe e tipos de usuário",
            desc: "Convide agentes e supervisores. O admin configura o negócio; cada agente atende seus departamentos.",
          },
          csat: {
            title: "CSAT",
            desc: "Meça a satisfação depois de cada atendimento.",
          },
        },
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Registre-se, agora mesmo!",
        },
      },
      plans: {
        title: "Planos",
        registerButton: "Registrar Plano",
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Mensagens em massa",
          groupCampaigns: "Campanhas para grupos",
          statusCampaigns: "Status do WhatsApp",
          negocio: "Módulo Negócio",
          schedules: "Agendamentos",
          internalUse: "Visível no cadastro público",
          internalPlan: "No cadastro",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "$",
        },
      },
      companies: {
        title: "Cadastrar empresa",
        form: {
          name: "Nome da empresa",
          email: "Correio eletrónico",
          phone: "Número do WhatsApp",
          plan: "Planos",
          status: "Estado",
          campaigns: "Campanhas",
          dueDate: "Data de vencimento",
          recurrence: "Recorrência",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
        table: {
          name: "Nome",
          email: "Correio eletrónico",
          phone: "Telefone",
          plan: "Planos",
          campaigns: "Campanhas",
          status: "Estado",
          createdAt: "Criada em",
          dueDate: "Vencimento",
        },
        messages: {
          loadError: "Não foi possível carregar a lista de registros",
          saveSuccess: "Operação concluída com sucesso!",
          saveError:
            "Não foi possível concluir a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos estão corretos.",
          deleteSuccess: "Operação concluída com sucesso!",
          deleteError: "Não foi possível concluir a operação",
          deleteTitle: "Eliminação de registro",
          deleteMessage: "Deseja realmente eliminar este registro?",
          registerRefreshPage: "Empresa registada. Atualize a página para ver as alterações.",
        },
        formTitle: {
          edit: "Editar empresa",
          registerNew: "Registar nova empresa",
        },
        sections: {
          basicInfo: "Informação básica",
          configuration: "Configuração",
        },
        loadingPlans: "A carregar planos...",
        timezone: {
          label: "Fuso horário",
          loading: "A carregar fusos horários...",
          loadingValue: "{{tz}} (a carregar...)",
          fallbackCurrent: "{{tz}} (actual)",
          hint: "Fuso horário para datas/horas em mensagens e tickets.",
          ariaLabel: "Fuso horário",
        },
        grid: {
          emptyTitle: "Não há empresas registadas",
          emptySubtitle: "Comece por registar a sua primeira empresa",
        },
        tooltips: {
          editCompany: "Editar empresa",
        },
        buttons: {
          clear: "Limpar",
          delete: "Eliminar",
          save: "Guardar",
          addDueDate: "+ Vencimento",
          user: "Utilizador",
          registerCompany: "Registar empresa",
          saving: "A guardar...",
        },
        register: {
          formTitle: "Registar nova empresa",
          companyInfoSection: "Informação da empresa",
          successTitle: "Empresa registada com sucesso!",
          loadPlansError: "Erro ao carregar os planos disponíveis",
          closingForm_one: "A fechar o formulário em {{count}} segundo...",
          closingForm_other: "A fechar o formulário em {{count}} segundos...",
          redirecting_one: "A redireccionar para o separador Empresas em {{count}} segundo...",
          redirecting_other: "A redireccionar para o separador Empresas em {{count}} segundos...",
          validation: {
            nameMin: "Nome demasiado curto",
            nameMax: "Nome demasiado longo",
            nameRequired: "Nome obrigatório",
            passwordMin: "Palavra-passe demasiado curta",
            passwordMax: "Palavra-passe demasiado longa",
            passwordRequired: "Palavra-passe obrigatória",
            emailInvalid: "Email inválido",
            emailRequired: "Email obrigatório",
            phoneMin: "Número de telefone demasiado curto",
            phoneRequired: "Número de WhatsApp obrigatório",
            planRequired: "Plano obrigatório",
          },
          buttons: {
            cancel: "Cancelar",
            back: "Voltar",
            registering: "A registar...",
            registered: "Registado!",
          },
        },
        values: {
          yes: "Sim",
          no: "Não",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semiannual: "Semestral",
          annual: "Anual",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          number: "Número",
          token: "Token",
          tokenEmpty: "Sem token (edite a conexão para definir um)",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "Avaliações",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          sendIdQueue: "Fila",
          timeSendQueue: "Redirecionar para fila em X minutos",
          queueRedirection: "Redirecionamento de Fila",
          outOfHoursMessage: "Mensagem de fora de expediente",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          prompt: "Prompt",
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          deletedAll: "Todos contatos excluídos com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          deleteAllTitle: "Deletar Todos",
          importTitle: "Importar contatos",
          exportTitle: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          deleteAllMessage:
            "Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.",
          importMessage:
            "Esta ação irá importar os contatos salvos na agenda do WhatsApp. Alguns modelos podem não permitir essa funcionalidade ou de acordo com sua configuração de privacidade! Verifique em até 1 hora o resultado.",
          exportMessage: "Tem certeza que deseja exportar os contatos selecionados?",
          exportAllMessage: "Tem certeza que deseja exportar todos os contatos?",
          importAgendaMessage: "Existem {count} contatos na sua agenda. Deseja importá-los?",
          titleExportAll: "Exportar todos os contatos",
          titleExportOne: "Exportar 1 contato",
          titleExportMany: "Exportar {{count}} contatos",
          titleDeleteOne: "Excluir 1 contato",
          titleDeleteMany: "Excluir {{count}} contatos",
          exportConfirmAll: "Tem certeza que deseja exportar todos os contatos?",
          exportConfirmMany: "Tem certeza que deseja exportar {{count}} contato(s)?",
          deleteSelectedMany:
            "Tem certeza que deseja excluir {{count}} contato(s)? Todos os tickets relacionados serão perdidos.",
        },
        tooltips: {
          importAgendaDisabled:
            "Esta funcionalidade está temporariamente desativada. O Baileys 6.7.21 não suporta obter contatos diretamente. Será reativada quando houver uma versão compatível do Baileys.",
        },
        buttons: {
          import: "Importar Contatos",
          importSheet: "Import. Excel",
          add: "Adicionar Contato",
          export: "Exportar Contatos",
          delete: "Excluir Todos Contatos",
          downloadTemplate: "Baixar modelo",
        },
        table: {
          profile: "Perfil",
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          lastInteraction: "Última interação",
          status: "Status",
          actions: "Ações",
        },
        messages: {
          selectToExport: "Selecione pelo menos um contato para exportar",
          processingExport: "Processando {count} contatos...",
          exportSuccess: "Contatos exportados com sucesso",
          exportError: "Erro ao exportar contatos",
          checkingAgenda: "Verificando agenda...",
          agendaEmpty: "Nenhum contato encontrado na agenda do telefone.",
          agendaUnavailable:
            "Não foi possível ler a agenda. Verifique se a conexão WhatsApp está online.",
          importInvalidResponse: "Resposta inválida do servidor",
          importErrorGeneric: "Erro ao importar contatos",
          templateDownloadSuccess: "Modelo baixado com sucesso",
          templateDownloadError: "Erro ao baixar o modelo",
        },
        pagination: {
          rowsPerPage: "Registros por página:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        badge: {
          contact: "contato",
          contacts: "contatos",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      sideMenu: {
        name: "Menu Lateral Inicial",
        note: "Se habilitado, o menu lateral irá iniciar fechado",
        options: {
          enabled: "Aberto",
          disabled: "Fechado",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de tokens na resposta",
          temperature: "Temperatura",
          apikey: "Chave da API",
          max_messages: "Máximo de mensagens no histórico",
          voiceKey: "Chave da API de voz",
          voiceRegion: "Região de voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar prompt",
          edit: "Editar prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          cancelUpper: "CANCELAR",
          expand: "AMPLIAR",
          saveChanges: "Salvar alterações",
        },
        sections: {
          provider: "Configuração do provedor de IA",
          api: "Configuração da API",
          basic: "Informações básicas",
          advanced: "Configurações avançadas",
          media: "Arquivos multimídia",
          workMode: "Modo de trabalho",
        },
        providerInfo: {
          title: "Configuração do provedor de IA",
          body1:
            "Selecione o provedor de inteligência artificial que este prompt usará. Cada um oferece modelos e recursos diferentes conforme sua necessidade.",
          body2:
            "Provedores disponíveis: OpenAI oficial, Google Gemini (AI Studio), Anthropic Claude, DeepSeek, Kimi e OpenRouter. Cada opção exige a chave de API desse provedor (OpenRouter usa sk-or-v1-…).",
        },
        mustValidateBeforeSave:
          "Valide a chave da API e o provedor antes de salvar. Use o botão «Testar conexão».",
        mustValidateBeforeSaveWithStored:
          "Se alterou o provedor ou colou uma chave nova, use «Testar conexão». Para só editar o texto/opções, deixe a chave em branco e mantenha o mesmo provedor.",
        validation: {
          nameRequired: "O nome é obrigatório",
          apiKeyRequired: "A chave da API é obrigatória",
          promptRequired: "O prompt é obrigatório",
          maxTokensRequired: "O máximo de tokens é obrigatório",
          temperatureRequired: "A temperatura é obrigatória",
          maxMessagesRequired: "O máximo de mensagens é obrigatório",
        },
        fields: {
          aiProvider: "Provedor de IA",
          promptName: "Nome do prompt",
          promptNameHelper: "Ex.: bot de suporte, assistente de vendas…",
          promptNamePlaceholder: "Ex.: bot de suporte",
          mainPrompt: "Prompt principal",
          mainPromptHelper: "Defina como a IA deve se comportar. Seja específico e claro.",
          mainPromptPlaceholder:
            "Você é um assistente de suporte técnico. Responda de forma profissional e útil…",
          charCount: "Quantidade de caracteres: {{count}}",
          temperature: "Temperatura",
          temperatureHelper: "0.0 = determinístico, 2.0 = muito criativo",
          maxTokens: "Máximo de tokens",
          maxTokensHelper: "Limite de tokens na resposta",
          maxMessages: "Máximo de mensagens",
          maxMessagesHelper: "Mensagens mantidas no contexto",
          queueOptional: "Departamentos (opcional)",
          noQueue: "Sem departamento",
          workModeLabel: "Modo de trabalho",
          workModeLayers: "Camadas contextuais",
          workModePdfs: "Documentos PDF",
          workModeHintLayers: "Usa camadas contextuais ativadas por palavras-chave",
          workModeHintPdfs: "Envie PDFs para a IA aprender com eles",
        },
        apiTest: {
          validating: "Validando…",
          validated: "✅ Validado",
          validatedHelper: "✅ Chave da API validada",
          storedKeyMaskPlaceholder:
            "Cole aqui apenas para trocar a chave (ao editar, a chave salva já aparece).",
          storedKeyHelper:
            "Ao editar este prompt você vê a chave da API armazenada no servidor. Deixe igual para mantê-la ou substitua para atualizar. Use «Testar conexão» para validar.",
          testConnection: "Testar conexão",
          enterApiKeyFirst: "Informe uma chave da API primeiro",
          selectProviderFirst: "Selecione um provedor primeiro",
          keyTooShortToast: "A chave da API parece muito curta. Verifique se está correta.",
          keyTooShort: "Chave da API muito curta",
          connectionSuccess: "Conexão bem-sucedida",
          validationFailed: "Falha na validação",
          validateError: "Erro ao validar a API",
          unknownError: "Erro desconhecido",
        },
        media: {
          savePromptFirst: "Primeiro salve o prompt",
          savePromptFirstToast: "Primeiro salve o prompt",
          unknownFileType: "Erro: tipo de arquivo não reconhecido",
          noFilesSelected: "Nenhum arquivo selecionado",
          unexpectedError: "Erro inesperado: {{message}}",
          fileDeleted: "Arquivo excluído com sucesso",
          deleteFileError: "Erro ao excluir arquivo: {{message}}",
          maxSixFiles: "Máximo de 6 arquivos por prompt",
          urlAdded: "URL externa adicionada com sucesso",
          urlAddError: "Erro ao adicionar URL: {{message}}",
          addUrl: "Adicionar URL",
          uploadFile: "Enviar arquivo",
          hintFiles:
            "📎 Você pode adicionar até 6 arquivos multimídia (imagens, vídeo, áudio, documentos)",
          hintLimits: "📏 Limites: imagens/áudio 10 MB, vídeo/documentos 15 MB",
          hintSyntax: "💡 Use [MEDIA: nomearquivo.ext] no prompt para referenciar arquivos",
          filesCount: "{{current}}/6 arquivos adicionados",
          uploadSuccessCount: "{{count}} arquivo(s) adicionado(s) com sucesso",
          maxSixWithCounts:
            "Máximo de 6 arquivos por prompt. Você já tem {{current}} e está adicionando {{adding}}. Só pode adicionar mais {{remaining}}.",
          maxSixNoMore:
            "Máximo de 6 arquivos por prompt. Você já tem {{count}} arquivos. Não é possível adicionar mais.",
          someRejected: "Alguns arquivos não puderam ser adicionados: {{list}}",
          fileTooBig: "{{name}}: excede {{maxMb}} MB",
          uploadPartial: "{{uploaded}} arquivo(s) adicionado(s), {{failed}} falharam: {{names}}",
          uploadFailedDetail: "Erro ao enviar arquivos: {{details}}",
          uploadNone: "Não foi possível enviar nenhum arquivo. Verifique o console para detalhes.",
        },
        urlDialog: {
          title: "Adicionar URL externa",
          urlLabel: "URL do arquivo",
          urlPlaceholder: "https://exemplo.com/arquivo.jpg",
          captionLabel: "Descrição (opcional)",
          captionPlaceholder: "Descrição do arquivo",
          hintPublic: "💡 Garanta que a URL seja acessível publicamente",
          add: "Adicionar",
          close: "Fechar",
        },
        expanded: {
          confirmClose: "Deseja salvar as alterações antes de fechar?",
          title: "Editor ampliado — prompt principal",
          unsavedChip: "Alterações não salvas",
          intro:
            "Edite seu prompt com mais espaço. Referências multimídia [MEDIA: nomearquivo.ext] aparecem destacadas na pré-visualização.",
          editorPlaceholder: "Escreva seu prompt aqui…",
          charCount: "Quantidade de caracteres: {{count}}",
          previewTitle: "Pré-visualização (destacada):",
          toastSaved: "Prompt atualizado com sucesso",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo de tokens (resposta)",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteTitleNamed: "Excluir o prompt «{{name}}»?",
          deleteMessage: "Tem certeza? Esta ação não pode ser desfeita!",
        },
        buttons: {
          add: "Adicionar prompt",
        },
        listPage: {
          title: "Prompts de IA",
          addButton: "Adicionar prompt",
          providersTitle: "Provedores de IA disponíveis",
          providersIntro:
            "Escolha o provedor que melhor atende às suas necessidades. Temos provedores oficiais: OpenAI, Gemini, Grok, Deepseek® e OpenRouter.",
          providersApiKey:
            "Cada um oferece modelos e recursos diferentes. Certifique-se de ter uma chave de API válida para o provedor selecionado.",
          tablePromptName: "Nome do prompt",
          tableProvider: "Provedor de IA",
          tableMaxTokens: "Máximo de tokens",
          tableTemperature: "Temperatura",
          tableMaxMessages: "Máximo de mensagens",
          tableActions: "Ações",
          tokensChip: "{{count}} tokens",
          tooltipEdit: "Editar prompt",
          tooltipDelete: "Excluir prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          whatsapp: "Conexão Origem: ",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar departamento",
          edit: "Editar departamento",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
        },
        tabs: {
          queueData: "Dados do departamento",
          serviceHours: "Horário de serviço",
        },
        automation: {
          title: "Automação de processos",
          intro:
            "Você pode automatizar conversas com prompts personalizados, fluxos (FlowBuilder), integrações externas ou um chatbot com menus de opções: o contato escolhe com botões no chat, não em texto livre. Apenas uma das quatro opções pode estar ativa por vez; nenhuma é obrigatória.",
        },
        form: {
          name: "Nome",
          departmentName: "Nome do departamento",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
          enableGreeting: "Ativar saudação",
          greetingEnabledOn: "Habilitado — a mensagem de boas-vindas será enviada.",
          greetingEnabledOff: "Desativado — nenhuma saudação é exibida ou enviada.",
          greetingRequired: "Se a saudação estiver ativa, preencha a mensagem.",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          ratingMessage: "Mensagem de avaliação",
          token: "Token",
          orderQueue: "Ordem da fila (Bot)",
          integrationId: "Integração",
          noIntegration: "Sem integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          attach: "Anexar Arquivo",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Tipo de usuário",
          whatsapp: "Conexão Padrão",
          whatsappHint:
            "Usada no inbox e no Negócio (entregas, lembretes e avisos). WhatsApp ou Telegram conforme a conexão.",
          language: "Idioma do painel",

          allTicket: "Ticket Sem Fila [Invisível]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Desabilitado",
          profileHint:
            "Admin configura o negócio. Supervisor vê todos os tickets dos seus departamentos. Agente atende só os seus.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          cancelMeeting: "Cancelar reunião",
          exit: "Sair",
        },
        selectConnectionPlaceholder: "Selecione uma conexão",
        bodyCharCounter: "{{current}}/500 caracteres",
        success: "Agendamento salvo com sucesso.",
        toasts: {
          deleted: "Arquivo excluído com sucesso.",
          meetingCancelled: "Reunião cancelada com sucesso",
          updated: "✅ Agendamento atualizado com sucesso",
          created: "✅ Agendamento criado com sucesso",
          noDataSave: "❌ Erro: não há dados para salvar",
        },
        confirmationModal: {
          deleteTitle: "Excluir arquivo",
          deleteMessage: "Deseja excluir este arquivo?",
        },
        cancelMeetingTitle: "Cancelar reunião",
        cancelMeetingMessage:
          "Tem certeza de cancelar esta reunião? Será enviada mensagem de cancelamento ao contato.",
        confirmScheduleTitle: "Confirmar agendamento?",
        confirmScheduleDate: "Data e hora:",
        confirmScheduleContact: "Contato:",
        confirmScheduleWhatsapp: "Conexão:",
        confirmScheduleMessage: "Mensagem:",
        confirmScheduleQuestion: "Confirma o agendamento com os dados exibidos?",
        validationErrorTitle: "❌ Erro de validação",
        understood: "Entendi",
        validationGeneric: "Erro ao validar o agendamento",
        contactNotFound: "Contato não encontrado",
        whatsappNotFound: "Conexão não encontrada",
        dialogStatusErro: "Erro de envio",
        dialogStatusPrefix: "Mensagem",
        autocompleteNoContacts: "Nenhum contato encontrado",
        searchContactLabel: "Digite para buscar contatos",
        searchContactPlaceholder: "Clique para ver contatos disponíveis",
        attachFile: "Anexar arquivo",
        validation: {
          required: "Obrigatório",
          invalidDateTime: "❌ Data/hora inválida",
          pastDateTime: "❌ Não é possível agendar no passado. Hora atual: {{now}}",
          minTenMinutes: "❌ Antecedência mínima de 10 minutos. Mais cedo permitido: {{min}}",
          maxOneYear: "❌ Não é possível agendar mais de 1 ano à frente",
          febMaxDays: "❌ Fevereiro não pode ter mais de 29 dias",
          feb29Leap: "❌ 29 de fevereiro só em anos bissextos",
          month30: "❌ O mês {{month}} não pode ter mais de 30 dias",
          bodyShort: "Mensagem muito curta",
          messageMax: "❌ A mensagem não pode exceder 500 caracteres",
          messageMinChars: "❌ A mensagem deve ter pelo menos 3 caracteres",
          messageMinValid: "❌ A mensagem deve ter pelo menos 2 caracteres válidos",
          allFieldsRequired:
            "❌ Todos os campos são obrigatórios: contato, conexão, mensagem e data/hora",
        },
        connectionFallback: "Conexão {{id}}",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
        },
        form: {
          name: "Nome",
          color: "Cor",
          namePlaceholder: "Ex.: Atendimento, Cliente, Interessado…",
          pickColorTitle: "Selecionar cor",
          kanbanLabel: "Usar no Kanban",
          kanbanHint: "Tags com Kanban ativo aparecem como colunas no quadro",
        },
        validation: {
          nameMin: "Nome muito curto",
          required: "Obrigatório",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
      },
      schedulePage: {
        moduleTitle: "Módulo da agenda",
        scheduledTotal: "{{count}} agendamentos",
        title: "Agendamentos ({{count}})",
        notAvailable: "N/D",
        viewTable: "Vista em tabela",
        viewCalendar: "Vista em calendário",
        newButton: "Novo agendamento",
        table: {
          date: "Data",
          time: "Hora",
          contact: "Contato",
          connection: "Conexão",
          message: "Mensagem",
          status: "Status",
          actions: "Ações",
        },
        status: {
          error: "Erro",
          cancelled: "Cancelado",
          sent: "Enviado",
          overdue: "Vencido",
          pending: "Pendente",
        },
        cancelMeetingTitle: "Cancelar reunião?",
        cancelScheduleTitle: "Cancelar agendamento?",
        cancelMeetingMessage:
          "Cancelar esta reunião? Todos os lembretes associados serão removidos.",
        cancelScheduleMessage:
          "Cancelar este agendamento? Será enviada mensagem de cancelamento ao contato.",
        toastMeetingCancelled: "Reunião cancelada com sucesso",
        toastScheduleCancelled: "Agendamento cancelado com sucesso",
        deleteTitleAlreadyCancelled: "Já cancelado",
        deleteTitleCancel: "Cancelar agendamento",
        calendar: {
          date: "Data",
          time: "Hora",
          event: "Evento",
          allDay: "Dia inteiro",
          week: "Semana",
          work_week: "Agendamentos",
          day: "Dia",
          month: "Mês",
          previous: "Anterior",
          next: "Próximo",
          yesterday: "Ontem",
          tomorrow: "Amanhã",
          today: "Hoje",
          agenda: "Agenda",
          noEventsInRange: "Não há agendamentos neste período.",
          showMore: "+{{total}} mais",
        },
      },
      appointmentsModule: {
        page: {
          moduleTitle: "Módulo da agenda",
          pendingLine: "• {{count}} solicitações pendentes",
          newAppointment: "Nova consulta",
          tabs: {
            dashboard: "Dashboard",
            calendar: "Calendário",
            pending: "Pendentes",
            history: "Histórico",
            settings: "Configuração",
          },
          accessDeniedTitle: "Sem acesso ao módulo Agenda",
          accessDeniedP1:
            "É preciso estar vinculado como profissional/instrutor em Agenda > Configuração > Equipe, ou ser administrador.",
          accessDeniedP2: "Fluxo: cadastre o usuário → depois vincule como Profissional na Equipe.",
          goHome: "Ir ao início",
          checkingAccess: "Verificando acesso…",
          allProfessionals: "Todos os profissionais",
        },
        status: {
          all: "Todos",
          pending: "Pendente",
          confirmed: "Confirmada",
          rescheduled: "Reagendada",
          in_progress: "Em andamento",
          completed: "Concluída",
          no_show: "Não compareceu",
          cancelled: "Cancelada",
        },
        calendar: {
          date: "Data",
          time: "Hora",
          event: "Evento",
          today: "Hoje",
          previous: "Anterior",
          next: "Próximo",
          month: "Mês",
          week: "Semana",
          day: "Dia",
          agenda: "Agenda",
          noEventsInRange: "Não há consultas neste período.",
          noName: "Sem nome",
          serviceFallback: "Serviço",
          code: "Código",
          detailsListTitle: "Detalhe das consultas",
          viewDetails: "Ver detalhes",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Telefone",
          },
        },
        dashboard: {
          wd0: "Seg",
          wd1: "Ter",
          wd2: "Qua",
          wd3: "Qui",
          wd4: "Sex",
          wd5: "Sáb",
          wd6: "Dom",
          kpiWeek: "Sessões esta semana",
          kpiPending: "Pendentes de confirmação",
          kpiToday: "Sessões hoje",
          kpiRate: "Taxa de comparecimento (30 dias)",
          chartTitle: "Sessões por dia — {{month}}",
          todayTitle: "Sessões de hoje",
          todayEmpty: "Não há sessões agendadas para hoje",
          todayLine: "{{time}}: {{contact}} — {{service}}",
          professionalPrefix: "Profissional:",
          upcomingTitle: "Próximas sessões",
          upcomingEmpty: "Não há sessões nos próximos 30 dias",
          chartConfirmed: "Confirmadas",
          chartPending: "Pendentes",
          chartCancelled: "Canceladas",
          code: "Código",
          viewDetails: "Ver detalhes",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Telefone",
          },
        },
        pendientes: {
          loading: "Carregando...",
          emptyHint: "Estas solicitações precisam da sua confirmação antes de serem agendadas",
          emptySub: "Não há solicitações pendentes",
          intro: "Estas solicitações precisam da sua confirmação antes de serem agendadas",
          noName: "Sem nome",
          serviceFallback: "Serviço",
          instructor: "Instrutor: {{name}}",
          chipPending: "Pendente",
          confirm: "Confirmar",
          reschedule: "Reagendar",
          cancel: "Cancelar",
          tooltipConfirm: "A consulta fica confirmada, aparece no Calendário e sai de Pendentes",
          tooltipReschedule: "Abre o modal para alterar o estado (ex.: confirmar, cancelar)",
          tooltipCancel: "Cancela a consulta; não aparecerá mais em Pendentes",
          code: "Código",
          bookedByAi: "Agendada pela IA",
          notes: "Notas",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Telefone",
          },
        },
        historial: {
          loading: "Carregando histórico…",
          empty: "Não há consultas com os filtros aplicados",
          emptyHint: "Ajuste as datas ou o estado no cabeçalho para ver mais resultados",
          countOrder: "{{count}} consultas · Ordem: {{order}}",
          orderAsc: "próximas primeiro",
          orderDesc: "mais recentes primeiro",
          changeOrder: "Alterar ordem",
          edit: "Editar",
          editReschedule: "Editar / Reagendar",
          editAria: "Editar consulta",
          tableAria: "Histórico de consultas",
          colDate: "Data",
          colTime: "Hora",
          colContact: "Contato",
          colService: "Serviço",
          colProfessional: "Profissional",
          colDetails: "Detalhes",
          colStatus: "Estado",
          colActions: "Ações",
          code: "Código",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Telefone",
          },
          rowsPerPage: "Linhas por página:",
          rowsPerPageShort: "Linhas:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        config: {
          firstTimeTitle: "Primeira vez configurando a Agenda?",
          firstTimeSubtitle: "Configure perfil, serviços, equipe e horários em poucos passos.",
          firstTimeCta: "Comece aqui",
          activeProfileTitle: "Perfil ativo: {{name}}",
          activeProfileSubtitle: "Altere qualquer parte da configuração inicial.",
          cardPerfilTitle: "Tipo de negócio / perfil",
          cardPerfilDesc:
            "Defina se é Beleza, Comercial, Saúde, Educação ou Técnico. Afeta textos e colunas Kanban.",
          cardServiciosTitle: "Serviços / programas",
          cardServiciosDesc: "Catálogo de serviços, disciplinas ou programas com duração e preço.",
          cardEquipoTitle: "Equipe de instrutores",
          cardEquipoDesc:
            "Profissionais que atendem. Vincule cada um a um usuário para acessar a Agenda e confirmar consultas.",
          cardHorariosTitle: "Horário de atendimento",
          cardHorariosDesc: "Dias, horários e duração dos slots por dia.",
          cardSecuenciasTitle: "Sequências automáticas do Agente IA",
          cardSecuenciasDesc:
            "Quando e como o Agente IA captura dados e dispara fluxos (pedido de consulta). O tom é configurado em Prompts IA.",
          equipoIntro:
            "Vincule cada profissional a um usuário (em Usuários) para entrar na Agenda e confirmar consultas.",
          equipoConfigureBtn: "Configurar equipe (nomes, funções e especialidades)",
          loadingProfessionals: "Carregando profissionais…",
          tableProfessional: "Profissional",
          tableRole: "Função / especialidade",
          tableLinkUser: "Vincular a usuário",
          noneUser: "— Nenhum —",
          noProfessionals:
            "Não há profissionais. Use o botão acima para adicionar a equipe na configuração inicial.",
          secuenciasIntro:
            "Escolha qual Agente IA (Prompt) captura pedidos de consulta no chat. Tom e personalidade ficam nesse agente.",
          loading: "Carregando…",
          agentLabel: "Agente IA para fluxo de consultas",
          noAgent: "— Nenhum (não usar Agente para consultas) —",
          noAgentsList: "Não há Agentes IA. Crie um em Prompts IA.",
          promptsLink: "Configurar tom e personalidade em Prompts IA",
          kanbanHint: "Se mudou o tipo de negócio, recrie as colunas Kanban do perfil atual.",
          kanbanRecreate: "Recriar colunas Kanban",
          kanbanProcessing: "Processando…",
          edit: "Editar",
          editSectionAria: "Editar {{section}}",
          toastLinkOk: "Vínculo atualizado. O instrutor pode acessar a Agenda com seu usuário.",
          toastKanbanOk: "Colunas Kanban recriadas conforme o perfil.",
          toastAgentOk: "Agente IA para fluxo de consultas atualizado.",
          errorProfileFirst: "Configure primeiro o perfil na configuração inicial.",
        },
        appointmentModal: {
          titleNew: "Nova consulta",
          titleEdit: "Consulta {{code}}",
          detailsTitle: "Dados da consulta",
          contactFallback: "Contato #{{id}}",
          client: "Cliente:",
          service: "Serviço:",
          professional: "Profissional:",
          date: "Data:",
          confirmationCode: "Código de confirmação",
          statusLabel: "Estado",
          viewProfile360: "Ver perfil 360",
          rescheduleHint:
            "Informe nova data, serviço e profissional para reagendar. Será enviada notificação ao contato.",
          newDateTime: "Nova data e hora *",
          duration: "Duração (minutos)",
          modality: "Modalidade",
          modalityPresential: "Presencial",
          modalityOnline: "Online",
          modalityPhone: "Telefone",
          locationDetail: "Localização / link",
          locationPlaceholder: "Endereço, sala ou link de reunião",
          notes: "Notas",
          bookedByAi: "Agendada pela IA",
          createdAt: "Criação",
          updatedAt: "Atualização",
          yes: "Sim",
          no: "Não",
          introNew:
            "Registre manualmente uma nova consulta. Digite para buscar e escolha na lista filtrada.",
          contactLabel: "Contato *",
          contactPlaceholder: "Digite nome ou número para buscar...",
          contactHelper: "Obrigatório. Busque por nome ou telefone.",
          noOptionsShort: "Digite pelo menos 2 caracteres para buscar",
          noOptionsEmpty: "Sem resultados",
          connectionLabel: "Conexão *",
          connectionPlaceholder: "Selecione a linha WhatsApp (conexão) desta consulta",
          connectionHelper:
            "Obrigatório. Indica sob qual conexão a consulta fica registrada (mesma lógica do lembrete agendado).",
          connectionNamed: "Conexão {{id}}",
          dash: "—",
          serviceField: "Serviço",
          serviceSearchPh: "Buscar serviço...",
          serviceHelper: "Opcional. Catálogo de serviços.",
          noServices: "Sem serviços configurados",
          professionalField: "Profissional",
          professionalSearchPh: "Buscar profissional...",
          professionalHelper: "Opcional. Equipe de instrutores.",
          noProfessionalsConfigured: "Sem profissionais configurados",
          datetimeLabel: "Data e hora *",
          datetimeHelper: "Obrigatório. Momento da consulta.",
          durationHelper: "Padrão 60 minutos.",
          notesPlaceholder: "Observações adicionais...",
          cancel: "Cancelar",
          saveReschedule: "SALVAR E REAGENDAR",
          saveStatus: "Salvar estado",
          create: "Criar consulta",
          toastContactDateRequired: "Contato e data são obrigatórios",
          toastWhatsappRequired: "Selecione a conexão (WhatsApp) da consulta",
          toastStatusUpdated: "Estado atualizado",
          toastCreated: "Consulta criada",
          toastRescheduleDateRequired: "A nova data é obrigatória para reagendar",
          toastRescheduled: "Consulta reagendada. Notificação enviada ao contato.",
        },
      },
      negocioModule: {
        mobileNav: {
          label: "Atalhos do Negócio",
          home: "Início",
          customers: "Clientes",
          services: "Serviços",
          collections: "Cobranças",
        },
        title: "Negócio",
        previewOnly: "Visível apenas para o dono do sistema · em construção",
        loading: "Carregando…",
        search: "Buscar…",
        empty: "Ainda não há registros. Crie o catálogo e as contas para começar a vender.",
        save: "Salvar",
        close: "Cancelar",
        edit: "Editar",
        cancel: "Cancelar",
        renew: "Renovar",
        markPaid: "Marcar como paga",
        toastSaved: "Salvo",
        phoneFormat: "Apenas o número local, sem o prefixo.",
        confirmTitle: "Confirmar ação",
        confirmBody: "Tem certeza de que deseja continuar?",
        deleteAccountBody: "A conta e todos os seus perfis serão excluídos. Só é possível se a conta já venceu (ou não tem data de vencimento) e nenhum cliente tem um serviço vigente nela.",
        confirmRemoveService: "Tem certeza de que deseja excluir este registro?",
        removeService: "Remover",
        due: {
          leftN: "Faltam {n} dias",
          tomorrow: "Vence amanhã",
          today: "Vence hoje",
          expiredN: "Venceu há {n} dias",
          expiredOne: "Venceu há 1 dia",
        },
        openInfo: "Ver informação",
        related: {
          accounts: "Ver contas",
          products: "Ver produtos",
          sales: "Ver movimentos",
          collections: "Ver cobranças",
          services: "Ver serviços",
          customers: "Ver cliente",
          suppliers: "Todos os fornecedores",
          combos: "Ver combos",
        },
        filters: { all: "Todos" },
        pager: {
          rows: "Linhas",
          shown: "{from}–{to} de {count}",
        },
        pages: {
          dashboard: {
            title: "Resumo",
            subtitle: "Lucro, vencimentos e vendas.",
            today: "Hoje",
            setup: "Como montar o negócio",
            step: "Passo",
            open: "Abrir",
            profit: "Lucro",
            monthResume: "Resumo do mês",
            vsPrev: "vs. período anterior",
            expiredBanner: "{n} perfil(is) já venceram",
            expiringBanner: "{n} perfil(is) vencem nos próximos 3 dias",
            pendingBanner: "{n} venda(s) com pagamento pendente",
            toRenew: "para renovar · clique para ver",
            toCollect: "a receber · clique para ver",
            profitByMonth: "Lucro por mês",
            rangeTotal: "Total do período",
            bestMonth: "Melhor mês",
            worstMonth: "Menor mês",
            byService: "Resumo por serviço",
            thisMonth: "Este mês",
            salesCount: "venda(s)",
            noServices: "Ainda não há vendas de produto neste mês.",
          },
          subscriptions: {
            title: "Cobranças",
            subtitle: "Serviços que vencem em 3 dias, vencem hoje ou já venceram.",
            emptyTitle: "Nada a vencer agora",
            empty: "Quando um serviço estiver a 3 dias, vencer hoje ou já estiver vencido, aparece aqui.",
            search: "Buscar por nome ou código…",
            pendingShort: "a receber",
            expiredShort: "vencido(s)",
            soonShort: "em 3 dias",
            todayShort: "hoje",
            sendReminders: "Enviar lembretes",
            remindersSent: "Envio de lembretes iniciado ({n}).",
            remindersRunning: "Já existe um envio de lembretes em curso.",
            kpis: {
              amount: "Na fila",
              soon: "Em 3 dias",
              today: "Vencem hoje",
              expired: "Vencidos",
              pending: "Pendentes",
              debtors: "Devedores",
            },
          },
          services: {
            title: "Serviços",
            subtitle: "Carrinho vivo de cada cliente. Adicione, renove ou remova. É a mesma base de toda a carteira.",
            emptyTitle: "Ainda não há serviços ativos",
            empty: "Adicione um produto a um cliente. Fica no carrinho e também é registrado em Movimentos.",
            search: "Buscar cliente ou serviço…",
            overdueBy: "há {n} d",
            daysLeft: "{n} dias",
            view: {
              cart: "Por cliente",
              list: "Lista",
            },
            kpis: {
              clients: "Clientes",
              live: "Serviços",
              expired: "Vencidos",
              pending: "A receber",
            },
            cart: {
              new: "Novo carrinho",
              config: "Configuração",
              pickCustomer: "Cliente",
              payment: "Forma de pagamento",
              payment2: "Segunda forma de pagamento",
              payment2Hint: "Opcional. Até dois métodos por cliente.",
              saleType: "Tipo de venda",
              saleTypes: {
                profile: "Perfil",
                full: "Conta completa",
                combo: "Combo",
              },
              saleTypeHints: {
                profile: "Só contas vendidas por perfil.",
                full: "Só contas vendidas completas.",
                combo: "Combos primeiro e depois todas as contas disponíveis.",
              },
              codes: "Sistema de códigos",
              codeUrl: "URL",
              codeUser: "Usuário",
              codePassword: "Senha",
              addItem: "Adicionar serviço",
              noItems: "Ainda não há serviços neste carrinho.",
              pickAccount: "Selecione produto e conta.",
              pickProfile: "Selecione o perfil.",
              comboUnavailable: "Não há contas livres para todos os produtos do combo.",
              comboHint: "Ao salvar, contas livres são atribuídas a cada produto do combo.",
              reviewSlots: "Contas e perfis do combo",
              reviewSlotsHint: "Foram escolhidos ao acaso. Abra para trocar antes de salvar.",
              shuffleSlots: "Sortear de novo",
              remove: "Excluir carrinho",
              removeBlocked: "Só é possível excluir se não houver serviços vigentes.",
              sendOrder: "Pedido",
              sendReminder: "Lembrete",
              sendUpdated: "Atualizado (5 min)",
              sendLast: "Último pedido (5 min)",
              sendRenewed: "Renovação (5 min)",
              renewExpired: "Renovar vencidos",
              renewExpiredOk: "Serviços renovados",
              pointsAccumulated: "Pontos acumulados",
              cartTotal: "Total da compra",
              currency: "Moeda",
              currencyLocal: "Moeda local",
              currencyFx: "Divisa",
              profit: "Lucro",
              profitHint: "Preço menos custo, sempre na moeda principal.",
              fxLocalHint: "Equivalente na moeda principal",
              contractDate: "Data de contratação",
              details: "Detalhes do serviço",
              itemCodes: "Sistema de códigos",
              paid: "Pago",
              unpaid: "Não pago",
              payWithWallet: "Pagar com saldo",
              payWithWalletHint: "Descontado da carteira do cliente na moeda dele. Se não for suficiente, nada é registrado. Pagar com saldo não gera cashback.",
              walletPaid: "Será pago com o saldo do cliente",
              payWithPrize: "Resgatar prêmio do sorteio",
              payWithPrizeHint: "30 dias de um serviço com estoque. Vence em {date}. Exige um serviço ativo e vigente.",
              prizeDaysHint: "O prêmio concede 30 dias. Vence",
              prizePaid: "Resgate de prêmio (sai no negativo)",
              prizeReady: "Prêmio para resgatar",
              ticketsLabel: "Bilhetes",
              raffleTickets: "{n} tickets este mês",
              sendPay: "Lembrete de pagamento",
              send: "Enviar",
              suggestedAccount: "Sugerido: o perfil livre foi escolhido ao acaso; você pode trocá-lo.",
              codePoolHint: "Se deixar vazio, um código do estoque será usado ({n} disponíveis).",
              panelStockHint: "Cole o código ou link gerado ao associar. Restam {n} nesta conta.",
            },
          },
          sales: {
            title: "Movimentos",
            subtitle: "Cada cobrança fica aqui. Não se apaga ao remover um serviço.",
            emptyTitle: "Ainda não há movimentos",
            empty: "Ao adicionar um serviço no carrinho, a cobrança é registrada aqui.",
            search: "Buscar cliente ou serviço…",
            export: "Exportar CSV",
            filterProduct: "Produto",
            filterCustomer: "Cliente",
            pickMonth: "Mês",
            pickYear: "Ano",
            chartTrend: "Por mês",
            chartByType: "Por tipo",
            chartByProduct: "Por produto",
            chartByCustomer: "Por cliente",
            chartClick: "Clique para filtrar · clique de novo para limpar",
            chartClientsN: "{n} clientes",
            chartOther: "Outros",
            kpis: {
              today: "Hoje",
              week: "Esta semana",
              month: "Este mês",
              year: "Este ano",
              historical: "Total histórico",
              count: "Movimentos",
            },
            types: {
              sale: "Receita",
              pending_payment: "A receber",
              redeem: "Troca de pontos",
            },
            periods: {
              all: "Tudo",
              today: "Hoje",
              week: "Semana",
              month: "Mês",
              year: "Ano",
            },
          },
          customers: {
            title: "Clientes",
            subtitle: "Agenda com foto do WhatsApp, código e serviços.",
            agendaSubtitle: "Agenda com foto do WhatsApp, código e serviços.",
            emptyTitle: "Ainda não há clientes do negócio",
            empty: "Adicione manualmente ou eles aparecem ao registrar uma venda.",
            active: "Serviços",
            noServices: "Este cliente ainda não tem assinaturas.",
            noSales: "Este cliente ainda não tem compras.",
            phoneHint: "Código do país e número, sem + nem espaços. Exemplo: 573001234567",
            telegramHint: "Usuário do Telegram, sem @. Obrigatório se não houver telefone.",
            phoneOrTelegram: "Informe telefone ou Telegram.",
            nameRequired: "O nome é obrigatório",
            unknownCountry: "País não identificado",
            openDetail: "Ver ficha",
            newTicket: "Criar conversa",
            openChat: "Ir para a conversa (abre a existente ou cria uma)",
            detailTitle: "Ficha do cliente",
            points: "Pontos",
            pointsOn: "Concede pontos",
            sendWallet: "Enviar saldo ao cliente",
            autoRenewOn: "Renova sozinho com saldo",
            autoRenewOff: "Sem renovação automática",
            discountPercent: "% de desconto (revendedor)",
            discountHint: "Aplica-se a novas compras no bot, na IA e nas vendas do painel. Não se aplica a renovações. Arredondado à centena.",
            metrics: {
              avgTicket: "Ticket médio",
              lastPurchase: "Última compra",
              daysAgo: "há {n} dias",
              frequency: "Frequência",
              everyDays: "a cada {n} dias",
              churn: "Risco de abandono",
              risk: { alto: "Alto", medio: "Médio", bajo: "Baixo" },
              autoRenew: "Renovação auto.",
              yes: "Sim",
              no: "Não",
            },
            pointsOff: "Sem pontos",
            sales: "Histórico de compras",
            purchases: "Compras",
            totalPurchases: "Total compras",
            pointsHistory: "Histórico de pontos",
            pointsEmpty: "Este cliente não tem movimentos de pontos.",
            pointsService: "Serviço",
            pointsReason: "Motivo",
            pointsPurchase: "Compra",
            pointsRedeem: "Resgate",
            services: "Serviços adquiridos",
            registeredAt: "Cliente desde",
            renewStartHint: "Dia seguinte ao vencimento anterior, para dar continuidade.",
            sendUpdated: "Enviar dados atualizados",
            sendRenewed: "Enviar mensagem de renovação",
            sendRenewTitle: "Enviar a mensagem de renovação?",
            sendRenewBody: "O serviço já foi renovado. Você pode avisar o cliente agora por WhatsApp ou Telegram, ou pular esta etapa.",
            sendPromptTitle: "Enviar a mensagem?",
            sendPromptBody: "Pode enviar agora por WhatsApp ou Telegram, ou saltar este passo.",
            sendNewServiceTitle: "Enviar os dados do novo serviço?",
            sendNewServiceBody: "Esta mensagem inclui os dados de acesso ou convite dos produtos que você acabou de adicionar. Se adicionar mais, todos vão no mesmo envio. O resumo do carrinho é enviado com Pedido.",
            sendSkip: "Agora não",
            sendingVia: "Enviando por {channel}…",
            addAnotherProduct: "Adicionar outro produto",
            createSaleTitle: "Criar uma venda?",
            createSaleBody: "O cliente já está pronto. Quer abrir um carrinho para vender agora?",
            createSaleYes: "Sim",
            createSaleNo: "Não",
            addProductsTitle: "Adicionar produtos?",
            addProductsBody: "O carrinho já está configurado. Quer adicionar produtos agora?",
            addProductsYes: "Sim",
            addProductsNo: "Não",
            swapProfile: "Trocar perfil",
            swapProfileTitle: "Mover para outra conta?",
            swapProfileBody: "Será buscada outra conta do mesmo produto com uma vaga livre (perfil, membro ou dispositivo) e reatribuída, sem criar uma venda nova. Útil se a plataforma expulsou o usuário.",
            swapProfileOk: "Conta e vaga alteradas",
            markedPaid: "Marcado como pago",
            markPaidBody: "O pagamento será marcado como recebido e o serviço ficará ativo.",
            payWithWallet: "Pagar com saldo",
            payWithWalletBody: "O valor da venda será descontado do saldo do cliente e o serviço ficará ativo. Pagar com saldo não gera cashback.",
            paidWithWallet: "Venda paga com o saldo do cliente",
            removeServiceTitle: "Remover serviço",
            removeServiceBody: "Tem certeza de que deseja excluir este registro?",
            sentOk: "Mensagem enviada",
            sendPointsTip: "Toque para enviar o saldo da carteira ao cliente",
            walletHistoryCurrencyHint: "Movimentos sem moeda registrada mostram apenas o valor original.",
            sendPointsTitle: "Enviar saldo da carteira:",
            templatesLink: "Editar modelo",
            types: {
              final: "Cliente",
              reseller: "Revendedor",
            },
            import: {
              action: "Importar",
              title: "Importar clientes de CSV",
              formatTitle: "Formato esperado",
              formatSample: "nombre,prefijo,telefono,tipo,email\nJuan Pérez,+57,3001234567,client,juan@example.com\nMaría López,+52,5512345678,client,\nPedro Gómez,+57,3119876543,reseller,",
              ruleName: "nome: 2-150 caracteres",
              rulePrefix: "prefixo: + e 1-4 dígitos (ex: +57)",
              rulePhone: "telefone: 6-30 dígitos (hífens/espaços são removidos)",
              ruleType: "tipo: client ou reseller",
              ruleEmail: "email: opcional, deixe vazio se não aplicar",
              ruleDupes: "Linhas com telefones ou emails duplicados são omitidas",
              ruleMax: "Máximo 1000 linhas por importação",
              pickFile: "Selecione um arquivo",
              dropHint: "CSV de no máximo 5 MB. Linhas inválidas são omitidas.",
              empty: "O arquivo não tem linhas válidas.",
              maxSize: "O arquivo não pode superar 5 MB.",
              done: "Foram sincronizados {created} clientes. Omitidos: {skipped}.",
            },
            kinds: {
              active: "Com serviço",
              expiring: "A vencer",
              expired: "Vencido",
              none: "Sem serviços",
            },
          },
          accounts: {
            title: "Contas",
            subtitle: "E-mail, perfis livres ou ocupados e vencimento.",
            emptyTitle: "Sem contas no inventário",
            empty: "Primeiro crie um produto. Depois adicione a conta; os perfis nascem livres quando aplicável.",
            profiles: "Perfis desta conta",
            noProfiles: "Esta conta ainda não tem perfis.",
            fullHint: "Venda de conta completa: não usa perfis.",
            fullHintMailbox: "Cada e-mail é uma unidade. Não há perfis: o Gmail/Outlook é entregue inteiro.",
            slotsFromProduct: "Vem do máximo de vagas do produto (perfis, membros ou dispositivos).",
            slotsEditableHint: "Ao salvar, criam-se as vagas faltantes para venda ou edição.",
            profileNameHint: "Será salvo como “nome 1”, “nome 2”, …",
            endDateHint: "Calculada com a data de contratação e os dias do plano.",
            profilePriceHint: "Preço de venda da conta dividido pelo número de perfis.",
            editProfile: "Ajustar perfil",
            editSlot: "Ajustar vaga",
            seeAllProfiles: "Ver todos",
            generatePin: "Gerar PIN",
            overdue: "Vencida",
            expiredBlocksAvailable: "Uma conta vencida não pode estar disponível. Renove as datas ou deixe-a em falha/repouso.",
            botPublish: "Publicar na loja do bot",
            botPublishHint: "Se ativo, o bot de WhatsApp/Telegram pode vender esta conta quando houver estoque livre.",
            botPublishBlocked: "Em falha ou repouso a conta não é publicada em nenhuma loja.",
            siteLoginHint: "Crie as vagas e depois edite cada uma para carregar URL, usuário e senha do site do cliente.",
            deleteSlot: "Excluir posto",
            deleteSlotConfirm: "Excluir este posto livre? Não pode ser desfeito.",
            deleteSlotBusy: "Só é possível excluir postos livres (sem cliente).",
            allProducts: "Todos os serviços",
            allSuppliers: "Todos os fornecedores",
            allCountries: "Todos os países",
            filterService: "Serviço",
            filterSupplier: "Fornecedor",
            filterCountry: "País",
            emailsBulkHint: "Um e-mail por linha. Opcional: e-mail,senha. O custo do lote é dividido entre as unidades.",
            lotHint: "Se comprou um lote (ex. 10 e-mails), anote quantas unidades o custo cobre.",
            unitCost: "Custo por unidade",
            remainingOne: "1 dia",
            remainingN: "{n} dias",
            daysOf: "{left} de {total} dias",
            stock: "Estoque",
            orders: "Pedidos",
            detail: "Detalhe da conta",
            accountSales: "Vendas desta conta",
            noSales: "Ainda não há vendas nesta conta.",
            updateNotifyTitle: "Enviar atualização aos clientes?",
            updateNotifyBody:
              "Há {count} serviço(s) nesta conta. A mensagem de atualização será enviada pelo WhatsApp (prioridade) e também pelo Telegram se o cliente tiver.",
            updateNotifySend: "Enviar agora",
            updateNotifyDone: "Atualização enviada: {sent} mensagem(ns) para {total} cliente(s).",
            filters: {
              available: "Disponíveis",
              occupied: "Vendidas",
              expiring: "A vencer",
              expired: "Vencidas",
              fault: "Com falha",
              pending: "Pendentes",
              renew: "Para renovar",
            },
            saleTypes: {
              profile: "Venda por perfil",
              profileHint: "Perfis livres são criados para vender um a um.",
              member: "Venda por membro",
              memberHint: "Membros são convidados um a um, sem PIN.",
              device: "Venda por dispositivo",
              deviceHint: "Cada vaga é um dispositivo. Não se atribuem mais do que o limite.",
              full: "Conta completa",
              fullHint: "A conta inteira é vendida, sem perfis.",
            },
            profileStatus: {
              available: "Livre",
              occupied: "Ocupado",
            },
            durations: {
              14: "14 dias",
              20: "20 dias",
              30: "1 mês",
              60: "2 meses",
              90: "3 meses",
              180: "6 meses",
              365: "1 ano",
            },
            billingType: {
              title: "Tipo de faturamento",
              hintAutopay: "Autopagável: não custa todo mês e se renova sozinha. Continua funcionando mesmo com dias negativos. Você pode anotar um custo de aquisição (pagamento único) ou deixar vazio.",
              hintCost: "De custo: você compra de um fornecedor e renova todo mês pagando um valor. Avisamos quando vencer para você renovar.",
              autopay: "Autopagável",
              autopaySub: "Renova sozinha",
              cost: "De custo",
              costSub: "Você renova todo mês",
              unlimited: "Ilimitado — se renova sozinha, não há data para acompanhar.",
              unlimitedShort: "Ilimitado",
            },
            costAutopay: "Custo (opcional · pagamento único)",
            costMonthly: "Custo (renovação mensal)",
            pinDisabledHint: "Esta conta terá perfis sem PIN.",
            currencyHint: "Você pode lançar compra ou venda na moeda principal ou na divisa. As duas ficam gravadas e visíveis.",
            salePrice: "Preço de venda",
            salePriceHint: "O que você cobra do cliente por esta conta. Digite na moeda principal ou na divisa; as duas ficam gravadas e visíveis.",
            purchaseCost: "Custo de compra",
            purchaseCostHint: "O que você paga ao fornecedor ao comprar ou renovar esta conta. Se todo mês você paga o mesmo, o custo de renovação é este mesmo valor.",
            unitCost30: "Custo de venda (30 dias)",
            unitCost30Hint: "Custo de compra levado a 30 dias e dividido entre os perfis. Se a conta é paga por ano, primeiro sai o custo de 30 dias e depois se divide.",
            suggestedSale: "Preço sugerido ({pct}% lucro): {price}",
            deviceLimitHint: "Só para produtos por dispositivos (CapCut, IPTV). Quantos dispositivos cabem nesta conta. Não vale para venda de conta completa tipo Netflix.",
            licenseCount: "Códigos ou links disponíveis",
            licenseCountHint: "Quantos códigos ou links restam nesta conta de painel. Diminuem a cada venda.",
            autopayDurationHint: "Serve para calcular o custo de 30 dias. A conta não vence sozinha.",
          },
          products: {
            title: "Produtos",
            subtitle: "Catálogo: entrega, plano e garantia. O preço ao cliente é definido em cada conta.",
            emptyTitle: "Crie o primeiro produto",
            empty: "Exemplo: Netflix. Depois você atribui contas e perfis.",
            namePlaceholder: "Ex.: Netflix, Disney+, HBO Max…",
            noDescription: "Sem descrição",
            announce: {
              action: "Aviso aos clientes",
              title: "Mensagem aos clientes do produto",
              hint: "Avise falhas gerais, mudanças de preço, novas condições ou qualquer mensagem formatada. Enviado por WhatsApp ou Telegram conforme o contato.",
              onlyActive: "Somente clientes com serviço ativo",
              loadingAudience: "Contando destinatários…",
              audience: "{total} destinatários ({wa} WhatsApp · {tg} Telegram)",
              message: "Mensagem",
              empty: "Escreva a mensagem antes de enviar",
              send: "Enviar aviso",
              sending: "Enviando…",
              sent: "Aviso enviado a {sent} de {total} clientes",
              partialErrors: "{n} envios falharam (veja os logs)",
            },
            preset: "Configurar como…",
            presetHint: "O modelo permanece selecionado e preenche tipo de venda, vagas e limite.",
            giftCardCostHint: "O que você paga por código. Pode lançar na moeda principal ou na divisa; as duas ficam gravadas.",
            giftCardPriceHint: "O que você cobra por código. Pode lançar na moeda principal ou na divisa; as duas ficam gravadas.",
            openSite: "Abrir site do produto",
            serviceUrlHint: "Ao clicar no logo, esta URL abre para iniciar sessão.",
            botSellable: "Vender pelo bot (WA / Telegram)",
            activationMode: "Ativação após o pagamento",
            activationModeHint: "Manual: o bot avisa o admin mesmo com Binance confirmado.",
            activationAuto: "Automática (entrega da conta)",
            activationManual: "Manual (assessor ativa)",
            slotKind: "Espaço que se vende",
            availableShort: "{n} disp.",
            managePlans: "Gerenciar planos em Configuração",
            planHint: "Escolha um plano ou digite um novo abaixo.",
            addPlanInline: "Novo plano",
            addPlanInlineBtn: "Adicionar plano",
            addPlanInlineHint: "Salvo no catálogo e disponível na hora.",
            createAccounts: "Criar conta(s)",
            createAccountsHint: "Abre o formulário de inventário deste produto (uma ou várias).",
            addAnotherAccountTitle: "Criar outra conta?",
            addAnotherAccountBody: "A conta foi salva. Quer adicionar outra deste produto?",
            addAnotherAccountYes: "Sim, outra",
            addAnotherAccountNo: "Pronto",
            ownership: {
              title: "Tipo de venda",
              hint: "Aluguel: o cliente usa e-mail e senha do inventário. Domínio: o serviço vai para o e-mail do cliente. Completa: entrega-se a conta inteira, sem perfis.",
              rental: "Aluguel",
              rentalHint: "Conta compartilhada: e-mail, senha e perfil. Também é possível vender a conta completa em cada unidade do inventário.",
              domain: "Domínio",
              domainHint: "Vende-se no e-mail do cliente (convite ou membro). A senha mestre não é compartilhada.",
              full: "Conta completa",
              fullHint: "Entrega-se e-mail e senha da conta inteira. Sem perfis nem PIN.",
            },
            presets: {
              streaming: "Streaming com perfis (Netflix, Max, Disney)",
              fullAccount: "Conta completa (e-mail e senha, sem perfis)",
              iptv: "IPTV / Flujo (usuário, senha e URL)",
              hostingSites: "Hosting / sites web (conta mãe + vagas com URL, usuário e senha)",
              family: "Familiar por convite (Spotify, YouTube)",
              canvaEdu: "Canva EDU / membro por e-mail",
              capcut: "Por dispositivos (CapCut)",
              code: "Código ou link (VPN, IA, recargas de PIN)",
              panel: "Códigos ou links gerados ao associar (painel)",
              recharge: "Recarga por ID (Free Fire)",
              mailbox: "E-mails avulsos (Gmail, Outlook)",
            },
            fulfillment: {
              title: "Como se entrega",
              credentials: "Aluguel (e-mail e senha)",
              invite: "Domínio (no e-mail do cliente)",
              code: "Código ou link",
              panel: "Painel",
              device: "Por dispositivos",
              recharge: "Recarga em um ID",
              mailbox: "E-mail entregue",
              license: "Licença / serviço",
              giftcard: "Gift card",
            },
            slotKinds: {
              none: "Sem vagas (conta, código ou recarga)",
              noneHint: "Vende-se a unidade completa; não há grade de perfis.",
              pin_profile: "Perfil com PIN",
              pin_profileHint: "Vagas com nome e PIN opcional, como Netflix ou Max.",
              email_member: "Membro por e-mail",
              email_memberHint: "A vaga é convidada para o e-mail do cliente. Sem PIN.",
              device: "Dispositivo",
              deviceHint: "Cada vaga é um dispositivo (CapCut, IPTV).",
              site_login: "Site web (URL + usuário + senha)",
              site_loginHint: "Hosting mãe: cada vaga é a página do cliente com URL, usuário e senha.",
            },
            logoType: "O logo deve ser JPG, PNG ou WebP.",
            logoSize: "O logo não pode ultrapassar 2 MB.",
            remove: "Excluir",
            createVariant: "Criar variante de plano",
            variantOf: "Variante de",
            variantHint: "Agrupa planos (Standard, Familiar, 1 dispositivo) no mesmo produto.",
            warrantyHint: "Dias de garantia no mensagem ao cliente. Deixe vazio se não aplicar.",
            priceHint: "Preço ao público (o que você cobra). Fica na moeda principal e também aparece na divisa pela taxa.",
            lotHint: "Tamanho típico de compra ao fornecedor (ex. lote de 10 e-mails).",
            durationPlans: {
              generate: "Criar planos 1 mês / 3 meses / 1 ano",
              hint: "Salve o produto e depois gere as variantes de duração.",
              saveFirst: "Salve o produto antes de gerar os planos de duração.",
              month: "1 mês",
              quarter: "3 meses",
              year: "1 ano",
              exists: "Este produto já tem as variantes de 1 mês, 3 meses e 1 ano.",
              created: "Foram criados {n} plano(s) de duração.",
            },
            codes: {
              title: "Estoque de códigos (um por linha)",
              hint: "Cole PIN, VPN ou licenças. Na venda é usado um só.",
              generatedHint: "Esses códigos são criados ao associar na plataforma. Anote quantos restam em cada conta; não são pré-carregados aqui.",
              stock: "{n} código(s) disponíveis. O que você colar agora entra no estoque.",
              stockLabel: "Códigos disponíveis",
              empty: "Não há códigos em estoque. Cole um aqui ou carregue-os no produto.",
              needStock: "Não há códigos em estoque para este produto.",
            },
          },
          catalog: {
            slots: {
              profile: { one: "Perfil", plural: "Perfis", max: "Máximo de perfis" },
              member: { one: "Membro", plural: "Membros", max: "Máximo de membros" },
              device: { one: "Dispositivo", plural: "Dispositivos", max: "Máximo de dispositivos" },
              site: { one: "Site", plural: "Sites", max: "Máximo de sites" },
              unit: { one: "Unidade", plural: "Unidades", max: "Unidades" },
            },
            offerTypes: {
              profile: "Perfil",
              full: "Completa",
              domain: "Domínio",
              device: "Dispositivo",
              mailbox: "E-mail",
              code: "Código",
              recharge: "Recarga",
            },
          },
          combos: {
            title: "Combos",
            subtitle: "Pacotes a preço especial, com contas vigentes.",
            emptyTitle: "Ainda não há combos",
            empty: "Crie um pacote de 2 a 6 produtos. Se tiver duração, é removido sozinho ao vencer.",
            noDescription: "Sem descrição",
            included: "Produtos incluídos",
            rangeHint: "Selecione entre 2 e 6 produtos com contas vigentes.",
            maxProducts: "O combo admite no máximo 6 produtos.",
            noEligible: "Não há produtos com contas vigentes (mais de 3 dias) para este tipo.",
            viableAccounts: "contas vigentes",
            permanent: "Permanente",
            permanentHint: "Este combo não caduca.",
            until: "Até",
            validity: "Vigência",
            typeProfileHint: "Só produtos com contas de venda por perfil e mais de 3 dias.",
            typeFullHint: "Só produtos com contas completas e mais de 3 dias.",
            priceHint: "Preço do pacote para o cliente. Digite na moeda principal ou na divisa.",
          },
          suppliers: {
            title: "Fornecedores",
            subtitle: "De quem você compra as contas. Telefone, Telegram e notas.",
            emptyTitle: "Sem fornecedores",
            empty: "Adicione um fornecedor se compra contas de terceiros. Você pode pular este passo.",
            search: "Buscar fornecedor…",
            phoneHint: "Código do país e número, sem + nem espaços. Exemplo: 573001234567",
            openAccounts: "Ver contas",
            linkedAccounts: "Contas vinculadas",
            noAccounts: "Sem contas vinculadas",
            noAccountsHint: "Quando você vincular contas a este fornecedor, elas aparecem aqui.",
          },
          codes: {
            lookup: "Consultar código",
            lookupTitle: "Resultado da consulta",
            copied: "Código copiado",
            copiedLink: "Link copiado",
            found: "Código encontrado",
            linkFound: "Link encontrado",
            bothFound: "Código e link encontrados",
            newSearch: "Nova busca",
            share: "Compartilhar",
            preview: "E-mail",
            empty: "Não há um código recente para este e-mail.",
            noSubject: "Sem assunto",
            imapHint: "Conecte até 4 caixas que recebem os códigos (IMAP). Gmail usa senha de aplicativo, porta 993.",
            imapOk: "Conexão IMAP correta",
            mailbox: "Caixa",
            server: "Servidor",
            lastOk: "Última conexão correta",
            user: "Usuário IMAP",
            userPlaceholder: "email@gmail.com",
            userRequired: "O usuário IMAP é obrigatório.",
            password: "Senha",
            passwordApp: "Senha / App Password",
            passwordKeep: "Nova senha (vazio para manter)",
            passwordConfigured: "Configurada",
            passwordHint: "Senha salva. Você pode testar a conexão ou trocá-la.",
            passwordHintNew: "Use a senha de aplicativo do Gmail, não a senha da conta.",
            passwordRequired: "Digite a senha de aplicativo para testar esta caixa.",
            host: "Host IMAP",
            port: "Porta",
            portHint: "Porta (993)",
            secure: "SSL/TLS",
            test: "Testar conexão",
            testing: "Testando…",
            testHint: "Teste host, porta, usuário e senha antes de salvar.",
            messagesCount: "{n} mensagens na caixa",
            removeMailbox: "Excluir caixa",
            operatorTitle: "Testar busca",
            operatorHint: "Só e-mails não lidos dos últimos 20 minutos. Código ou link antigo já não serve.",
            email: "E-mail da conta",
            filters: "Filtros de consulta",
            filtersHint: "Assuntos que devem aparecer no e-mail. Ative para usar na busca.",
            subject: "Assunto / condição",
            active: "Ativo",
            useInSearch: "Usar",
            addFilter: "Adicionar assunto",
            removeFilter: "Remover assunto",
            landingUrl: "Link de consulta",
            landingHint: "Criado ao ativar o sistema de códigos. O cliente abre esta página e só vê os e-mails dele.",
            generating: "Criando link…",
            optionalPortal: "Usuário e senha de um portal externo (opcional)",
            externalPortal: "Portal externo",
            externalPortalHint: "Só se você usa outra página.",
            serviceSubjects: "Assuntos da consulta",
            serviceSubjectsHint: "A busca usa só estes assuntos no e-mail da conta deste serviço.",
            noProductSubjects: "Este produto não tem assuntos. Configure-os em Produtos.",
          },
          payments: {
            title: "Métodos de pagamento",
            subtitle: "Nequi, transferência ou outro meio. Ative ou desative cada um.",
            emptyTitle: "Sem métodos de pagamento",
            empty: "Nequi, transferência, USDT ou outro meio com que você recebe.",
          },
          settings: {
            subtitle: "Usuários, moeda, pagamentos, mensagens, lembretes e condições do negócio.",
            tabs: {
              users: "Usuários",
              plans: "Planos",
              currency: "Moeda",
              payments: "Pagamentos",
              messages: "Mensagens",
              reminders: "Lembretes",
              terms: "Condições de uso",
              raffle: "Sorteio mensal",
              points: "Pontos",
              loyalty: "Fidelização",
              codes: "Códigos",
              bot: "Bot WA / Telegram",
              migrate: "Migrar AppSheet",
            },
            paymentsUnifiedHint: "Moeda, taxa, lucro e métodos de cobrança.",
            messagesUnifiedHint: "Modelos de entrega/renovação e lembretes automáticos de vencimento.",
            loyaltyHint: "Pontos por compra e sorteio mensal para fidelizar clientes.",
            paymentMethodsTitle: "Métodos de pagamento",
            codesHint: "Até 4 caixas IMAP e um teste de busca. Os filtros de assunto ficam em cada produto.",
            botHint: "Ative o bot da loja no WhatsApp e/ou Telegram separadamente. No Telegram use token do @BotFather para botões nativos.",
            migrateHint: "Importe o Excel do AppSheet / StreamDigi (Base.xlsx) para este negócio: produtos, contas, perfis, clientes, vendas, assinaturas e pontos.",
            migrateSheets: "Planilhas lidas: Productos, Proveedores, M_Pago, Cuentas, Perfiles, Cliente, Ventas, Base, Control_Ingresos, Puntos.",
            migratePickFile: "Escolher Excel (.xlsx)",
            migrateChangeFile: "Trocar arquivo",
            migrateReplace: "Substituir dados atuais do negócio",
            migrateReplaceHint: "Se ativo, apaga produtos, contas, vendas e assinaturas desta empresa antes de carregar. Ajustes (bot, IMAP, lembretes) são mantidos.",
            migratePreview: "Pré-visualizar",
            migrateRun: "Migrar agora",
            migratePreviewTitle: "Pré-visualização do arquivo",
            migrateResultTitle: "Resultado da migração",
            migrateMissingSheets: "Faltam planilhas obrigatórias no Excel.",
            migratePreviewOk: "Arquivo válido. Revise os totais e execute a migração.",
            migrateReady: "Pronto para migrar",
            migrateMissing: "Faltam",
            migrateDone: "Migração concluída",
            migrateStarted: "Migração iniciada no servidor. Pode levar alguns minutos; não a repita.",
            migrateFailed: "A migração falhou",
            migrateConfirmTitle: "Migrar base AppSheet?",
            migrateConfirmReplace: "Os dados atuais do negócio serão substituídos pelo Excel. Esta ação não pode ser desfeita.",
            migrateConfirmKeep: "Os dados do Excel serão adicionados aos existentes. Pode gerar duplicados se já migrou antes.",
            botEnabled: "Bot ativo",
            botWhatsappEnabled: "Bot ativo no WhatsApp",
            botTelegramEnabled: "Bot ativo no Telegram",
            botPromoEnabled: "Mostrar atalho PROMO no menu",
            botGuidedOnly: "Apenas menu guiado (sem texto livre)",
            botWalletEnabled: "Carteira do cliente (pagar / renovar com saldo)",
            botRatingEnabled: "Pedir avaliação após a entrega (pesquisa 1-3)",
            botShopName: "Nome da loja",
            botShopNameHint: "Aparece na boas-vindas e no recibo de entrega.",
            botTelegramToken: "Token do bot Telegram (@BotFather)",
            botTelegramTokenHint: "Crie o bot com @BotFather, cole o token e salve.",
            botTelegramTokenHintSet: "Token salvo. Deixe vazio para não alterar. Bot ativo:",
            botAdminNumber: "WhatsApp do admin (alertas)",
            botAdminNumberHint: "Recebe pedidos novos, pagamentos a validar e escalações de suporte.",
            botAdminTelegram: "Usuário Telegram do admin",
            botAdminTelegramHint: "Sem @. Exemplo: meuusuario. Requer conexão Telegram ativa.",
            botSalesQueue: "Departamento Vendas",
            botSupportQueue: "Departamento Suporte",
            botQueueNone: "Sem departamento",
            botQueueHint: "Lista de Configuração → Departamentos. Ao escalar, o ticket fica nesse departamento (pendente).",
            botQueueEmpty: "Não há departamentos. Crie-os em Configuração → Departamentos.",
            botWelcome: "Mensagem de boas-vindas",
            botWelcomeHint: "Use negrito/itálico, variáveis e uma imagem. Prévia à direita. Vazio = saudação automática.",
            botWelcomePlaceholder: "Ex: Olá {{nombre_cliente}}! 👋 Bem-vindo à StreamDigi…",
            varCustomerName: "Nome completo",
            varFirstName: "Primeiro nome",
            usersHint: "WhatsApp com que cada usuário envia as mensagens do negócio.",
            plansHint: "Nomes de plano ao criar um produto: Standard, Familiar, EDU, 1 tela…",
            planName: "Nome do plano",
            addPlan: "Adicionar plano",
            resetPlans: "Restaurar lista",
            noPlans: "Sem planos. Adicione um ou restaure a lista padrão.",
            noUsers: "Não há usuários",
            noUsersHint: "Os usuários da empresa aparecem aqui para atribuir uma conexão.",
            whatsapp: "Conexão WhatsApp",
            currencyHint: "Moeda principal, símbolo, taxa frente à divisa e percentual de lucro.",
            currencyLocal: "Moeda local",
            currencyFx: "Divisa",
            currencySymbol: "Símbolo",
            currencyLocalHint: "A moeda em que fica o preço ao público. A divisa é calculada com a taxa.",
            currencyFxHint: "A moeda secundária (divisa) contra a qual a taxa é cruzada (quase sempre USD).",
            currencySymbolHint: "Aparece junto aos preços. Exemplo: $ 10.000",
            profitPercent: "% de lucro",
            profitPercentHint: "O preço de venda de cada perfil ou conta completa = custo de venda × (1 + este %). Exemplo: 50 = cobrar 50% sobre o custo.",
            timezoneTitle: "Fuso horário",
            timezoneHint: "Períodos, vencimentos, programações e qualquer data/hora do negócio usam este fuso, o mesmo de Configurações. Não usa o do servidor nem o do navegador.",
            timezoneChange: "Alterar em Configurações",
            exchangeRate: "Taxa de câmbio (local por 1 estrangeira)",
            fetchRate: "Atualizar taxa",
            fetchingRate: "Consultando…",
            rateUpdated: "Taxa do dia",
            rateCached: "Taxa de hoje (já consultada)",
            rateDaily: "Edite a taxa e salve para aplicar em todo o módulo. Para consultar a taxa atual, clique em Atualizar taxa e depois Salvar.",
            rateInvalid: "Insira uma taxa de câmbio maior que zero.",
            rateError: "Não foi possível consultar a taxa agora. Verifique a conexão ou digite e salve.",
            example: "Exemplo de conversão",
            messagesHint: "Textos ao vender, renovar ou avisar vencimento.",
            generalMessages: "Mensagens gerais",
            productOverride: "Deixe vazio para usar a mensagem geral ou escreva um texto só deste produto.",
            saleMessage: "Dados da compra (ao atribuir)",
            renewMessage: "Mensagem de renovação",
            expireMessage: "Alerta de vencimento",
            reminderWalletMessage: "Incluir mensagem de saldo disponível",
            reminderWalletMessageHint: "Envia uma mensagem adicional quando o saldo permite renovar pelo menos um serviço.",
            pointsMessage: "Saldo de pontos",
            updateMessage: "Dados atualizados do serviço",
            pointsMessagePlaceholder: "Mensagem com o saldo atual de pontos do cliente.",
            pointsMessageHint: "Enviada ao tocar no total de pontos do cliente (Clientes, carrinho e ficha do cliente). Também usada nos lembretes com pontos.",
            pointsEarnedEnabled: "Enviar mensagem de pontos ganhos ao entregar um pedido",
            pointsEarnedMessage: "Pontos ganhos na compra",
            pointsEarnedMessagePlaceholder: "Pontos ganhos na compra, total acumulado e condições de uso.",
            pointsEarnedHint: "Enviada como mensagem separada, logo após enviar os dados das contas adicionadas ao serviço, somente se a compra foi paga e gerou pontos.",
            updateMessagePlaceholder: "Enviado só depois de editar um serviço (não numa renovação).",
            saleMessagePlaceholder: "Dados da conta que o cliente recebe ao comprar.",
            renewMessagePlaceholder: "Texto quando o serviço é renovado.",
            expireMessagePlaceholder: "Aviso antes ou no vencimento.",
            messagePlaceholder: "Toque uma variável e escreva o texto. Os valores entram no envio.",
            saveTemplates: "Salvar modelos",
            preview: "Prévia",
            previewEmpty: "Escreva uma mensagem para ver a prévia.",
            attached: "Arquivo anexado",
            removeMedia: "Remover",
            newReminder: "Novo lembrete",
            remindersHint: "Avisos dias antes, no mesmo dia ou após o vencimento, na hora configurada.",
            noReminders: "Sem lembretes",
            noRemindersHint: "Crie um com dias antes, no mesmo dia (0) ou dias após o vencimento (negativo).",
            when: "Quando",
            daysOffset: "Dias conforme o vencimento",
            reminderType: "Tipo de lembrete",
            reminderExpiration: "Vencimento do serviço",
            reminderPayment: "Falta de pagamento",
            reminderExpirationHint: "Baseado na data de vencimento do serviço.",
            reminderPaymentHint: "Apenas serviços com venda pendente de pagamento. Para ao registrar o pagamento.",
            paymentDays: "Dias desde a venda pendente",
            paymentDaysHint: "0 = desde o dia da venda. 3 = a partir do terceiro dia sem pagamento. Independente do vencimento.",
            paymentDaysSummary: "A partir de {{n}} dia(s) sem pagamento",
            paymentFrequencyOnce: "Uma vez por venda pendente",
            paymentFrequencyHint: "Diário: repete enquanto estiver pendente. Uma vez: um aviso por venda pendente.",
            daysOffsetHint: "3 = três dias antes. 0 = no mesmo dia. -3 = três dias vencido.",
            daysBefore: "{{n}} dias antes",
            daysAfter: "{{n}} dias vencido",
            daysSame: "No dia do vencimento",
            frequency: "Frequência",
            frequencyDaily: "Todos os dias",
            frequencyOnce: "Uma vez",
            frequencyHint: "Diário: envia todos os dias em que a regra se cumpra. Uma vez: só no primeiro dia.",
            sendHour: "Hora de envio",
            sendHourHint: "Se vários lembretes tiverem a mesma hora, enviam-se pela ordem desta lista.",
            notifyNumber: "WhatsApp de notificação",
            notifyHint: "Número que recebe aviso quando este lembrete envia mensagens.",

            reminderIncludePoints: "Incluir mensagem de pontos para renovar",
            reminderIncludePointsHint: "Só é enviada se o cliente tiver pontos suficientes para resgatar pelo menos um serviço do aviso. A mensagem indica para quais alcança (e se alcança para todos).",
            reminderExtraMessage: "Mensagem adicional",
            reminderExtraMessageHint: "Opcional. Enviada após o lembrete principal, com as mesmas variáveis ({{nombre}}, {{servicios}}, …).",
            reminderMessage: "Mensagem",
            termsHint: "Vigência, uso permitido, suporte e reembolsos. Sem dados de contas.",
            raffleHint: "Tickets por compra ou renovação, sorteio no dia 1, prêmio de 30 dias e mensagens ao ganhador.",
            pointsHint: "Equivalência, se o sistema está ativo, e as regras de pontos.",
            pointsSystemEnabled: "Ativar sistema de pontos",
            pointsEquivalence: "Equivalência ao conceder (valor da venda ÷ este número)",
            pointsEquivalenceExample: "Exemplo: {amount} ÷ {eq} = {points} pontos",
            raffleEnabled: "Ativar sorteio",
            raffleDay: "Dia do sorteio",
            raffleDayHint: "O dia 1 sorteia as compras e renovações do mês anterior. Os tickets só são gravados se o sorteio estiver ativo.",
            raffleLastDay: "Último dia do mês",
            raffleWinnerMessage: "Mensagem ao ganhador",
            raffleWinnerPlaceholder: "Parabéns {{nombre_cliente}}. Você ganhou o sorteio de {{mes}} com {{tickets_ganador}} tickets. Resgate 30 dias até {{premio_vence}}.",
            raffleAnnounceMessage: "Anúncio aos clientes com serviços ativos",
            raffleAnnouncePlaceholder: "O ganhador do sorteio de {{mes}} é {{nombre_ganador}}. Cada compra soma um ticket.",
            raffleReportNumber: "WhatsApp do relatório",
            raffleReportNumberHint: "Número que recebe o relatório do sorteio (ganhador, tickets, enviados).",
            termsPlaceholder: "Escreva as condições de uso: vigência, uso permitido, suporte e reembolsos.",
            rafflePlaceholder: "Escreva as regras do sorteio: data, prêmio, clientes elegíveis e como o ganhador é anunciado.",
            pointsPlaceholder: "Explique como se ganha saldo (cashback), como usá-lo para pagar e sua validade. O Agente IA usa este texto.",
            cashbackTemplate: "Usar modelo de cashback",
          },
        },
        setup: {
          products: { title: "Produtos", desc: "Defina o que você vende e a que preço.", cta: "Criar produto" },
          payments: { title: "Métodos de pagamento", desc: "Indique como os clientes pagam.", cta: "Adicionar método" },
          accounts: { title: "Inventário", desc: "Carregue e-mails, senhas e perfis prontos para atribuir.", cta: "Adicionar conta" },
          sales: { title: "Primeira venda", desc: "Escolha um contato, um produto e um perfil livre.", cta: "Registrar venda" },
        },
        tabs: {
          dashboard: "Dashboard",
          subscriptions: "Assinaturas",
          sales: "Vendas",
          accounts: "Contas",
          products: "Produtos",
          suppliers: "Fornecedores",
          payments: "Métodos de pagamento",
        },
        new: {
          products: "Novo produto",
          product: "Novo produto",
          suppliers: "Novo fornecedor",
          supplier: "Novo fornecedor",
          payments: "Novo método",
          payment: "Novo método de pagamento",
          accounts: "Nova conta",
          account: "Nova conta",
          sales: "Nova venda",
          sale: "Adicionar serviço",
          customer: "Novo cliente",
          combo: "Novo combo",
        },
        kpi: {
          activeSubs: "Serviços ativos",
          expiringSubs: "Vencem em 3 dias",
          expiredSubs: "Vencidos",
          availableProfiles: "Perfis livres",
          accounts: "Contas no inventário",
          products: "Produtos",
          pendingSales: "Vendas a receber",
          monthTotal: "Vendas do mês",
          monthProfit: "Lucro do mês",
          yearProfit: "Lucro do ano",
          weekProfit: "Esta semana",
          historicalProfit: "Total histórico",
          monthIncome: "Receitas",
          monthCost: "Despesas",
        },
        cols: {
          contact: "Cliente",
          product: "Produto",
          account: "Conta",
          profile: "Perfil",
          endDate: "Vence",
          price: "Preço",
          status: "Status",
          total: "Total",
          payment: "Pagamento",
          date: "Data",
          email: "E-mail",
          supplier: "Fornecedor",
          slots: "Vagas",
          name: "Nome",
          days: "Dias",
          phone: "Telefone",
          type: "Tipo",
          code: "Código",
          telegram: "Telegram",
          points: "Pontos",
          maxProfiles: "Máx. perfis",
          accounts: "Contas",
          availableAccounts: "Disponíveis",
          records: "Registros",
          activeAccounts: "Ativas",
          password: "Senha",
          profiles: "Perfis",
          billing: "Faturamento",
          remaining: "Restantes",
          service: "Serviço / combo",
          accountNumber: "Número / conta",
          plan: "Plano",
          country: "País",
          warranty: "Garantia",
          lot: "Lote",
        },
        fields: {
          name: "Nome",
          description: "Descrição",
          days: "Duração (dias)",
          price: "Preço",
          cost: "Custo",
          phone: "Telefone",
          prefix: "Prefixo",
          notes: "Notas",
          type: "Tipo",
          accountNumber: "Número da conta",
          reference: "Referência",
          product: "Produto",
          supplier: "Fornecedor",
          email: "E-mail da conta",
          loginUser: "Usuário",
          loginUserHint: "Usuário do painel IPTV/Flujo (não precisa ser e-mail).",
          panelUrl: "URL do painel (opcional)",
          panelUrlHint: "Ex.: http://servidor:porta — enviada ao cliente na entrega.",
          hostingAccount: "Conta mãe (identificador)",
          hostingAccountHint: "Nome ou código do hosting mãe. Os dados do cliente vão em cada vaga.",
          siteUrl: "URL do site",
          siteUrlHint: "Página do cliente (ex. https://cliente.seudominio.com).",
          siteUser: "Usuário",
          siteUserHint: "Usuário de acesso à página do cliente.",
          sitePassword: "Senha",
          pin: "PIN",
          password: "Senha",
          passwordKeep: "Deixe vazio para não alterar",
          slots: "Quantidade de perfis",
          startDate: "Início",
          none: "— Nenhum —",
          contact: "Contato *",
          contactHint: "Digite pelo menos 2 letras para buscar em Contatos.",
          profile: "Perfil a atribuir",
          assignLater: "Atribuir depois",
          payment: "Método de pagamento",
          accountType: "Tipo de conta",
          identityNumber: "Número de ID",
          comment: "Comentário",
          customerType: "Tipo de cliente",
          telegram: "Usuário do Telegram",
          pointsEnabled: "Conceder pontos por compras",
          maxProfiles: "Máximo de perfis",
          logo: "Logo (JPG, PNG ou WebP, máx. 2 MB)",
          logoHint: "Ajustado para 200×200 px. Clique para enviar.",
          serviceUrl: "URL do serviço (opcional)",
          isActive: "Produto ativo",
          accountStatus: "Status da conta",
          saleType: "Tipo de conta",
          pinLength: "Caracteres do PIN",
          pinCustom: "PIN personalizado",
          pinEnabled: "PIN dos perfis",
          planLabel: "Plano (Standard, Familiar, EDU…)",
          originCountry: "País da conta",
          deviceLimit: "Máximo de dispositivos",
          memberEmail: "E-mail do membro",
          deliveryCode: "Código ou link de entrega",
          externalId: "ID da recarga",
          warrantyDays: "Dias de garantia",
          lotSize: "Unidades do lote",
          parentProduct: "Variante de (produto pai)",
          emailsBulk: "Lote de e-mails (um por linha)",
          mailboxEmail: "E-mail a entregar",
          customProfileName: "Nome de perfil personalizado",
          profileNamePrefix: "Nome base do perfil",
          endDate: "Data final",
          profilePrice: "Custo de venda por perfil",
          comboPrice: "Preço do combo",
          isPermanent: "Combo permanente (não caduca)",
          durationDays: "Dias de duração",
          ip: "IP",
        },
        status: {
          active: "Ativo",
          pending: "Pendente",
          pending_payment: "A receber",
          paid: "Paga",
          expired: "Vencido",
          cancelled: "Cancelado",
          fault: "Com falha",
          idle: "Repouso",
          available: "Disponível",
          assigned: "Atribuído",
          disabled: "Inativo",
          expiring: "A vencer",
          soon: "Em 3 dias",
          today: "Hoje",
          none: "Sem serviços",
          sold: "Vendido",
        },
      },
      toDoList: {
        title: "Tarefas do operador",
        loading: "Carregando tarefas...",
        searchPlaceholder: "Buscar tarefas…",
        stats: {
          total: "Total",
          pending: "Pendentes",
          completed: "Concluídas",
          urgent: "Urgentes",
        },
        form: {
          newTask: "Nova tarefa",
          editTask: "Editar tarefa",
          descriptionLabel: "Descrição da tarefa",
          descriptionPlaceholder: "Ex.: Revisar configuração do servidor…",
          priority: "Prioridade",
          category: "Categoria",
          add: "Adicionar tarefa",
          save: "Salvar alterações",
          cancel: "Cancelar",
        },
        priority: { low: "Baixa", medium: "Média", high: "Alta" },
        categories: {
          general: "Geral",
          urgent: "Urgente",
          followup: "Acompanhamento",
          meeting: "Reunião",
          system: "Sistema",
          customer: "Cliente",
        },
        filters: {
          title: "Filtros",
          all: "Todas",
          allCategories: "Todas as categorias",
          allStatus: "Todos",
          status: "Estado",
          clear: "Limpar filtros",
        },
        statusLabel: { pending: "Pendente", completed: "Concluída" },
        empty: {
          none: "Nenhuma tarefa criada",
          noneHint: "Crie sua primeira tarefa no formulário acima",
          filtered: "Nenhuma tarefa com os filtros aplicados",
          filteredHint: "Ajuste os filtros para ver mais tarefas",
        },
        details: {
          title: "Detalhe da tarefa",
          content: "Conteúdo",
          priority: "Prioridade",
          category: "Categoria",
          status: "Estado",
          id: "ID",
          createdAt: "Criação",
          updatedAt: "Última atualização",
          notAvailable: "Não disponível",
          close: "Fechar",
        },
        tooltips: {
          markPending: "Marcar como pendente",
          markDone: "Marcar como concluída",
          edit: "Editar tarefa",
          delete: "Excluir tarefa",
        },
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
          closeallTicket: "Fechar",
        },
        confirmation: {
          title: "⚠️ Confirmação de fechamento de tickets",
          subtitle: "Esta ação fechará TODOS os tickets abertos de forma permanente",
          warning: "Esta ação não pode ser desfeita",
          whichTicketsQuestion: "Quais tickets deseja fechar?",
          noTicketsForOption: "Não há tickets para fechar conforme a opção selecionada",
          warningEmojiAria: "Aviso",
          optionAttendingOpen: "EM ATENDIMENTO (Abertos)",
          optionPending: "PENDENTE",
          optionBoth: "AMBOS (EM ATENDIMENTO + PENDENTE)",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
          filterConnections: "Filtro por conexões",
          filterContacts: "Filtro por contato",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          ticketsPerPage: "Tickets por página",
          searchMessagesTooltip: "Buscar também no conteúdo das mensagens (mais lento)",
        },
        buttons: {
          showAll: "Todos",
        },
        managerTabs: {
          tooltips: {
            newTicket: "Criar novo ticket",
            resolveTickets: "Resolver tickets",
            showOpen: "Mostrar tickets abertos",
            showClosed: "Mostrar tickets fechados",
            filterByQueues: "Filtrar por filas",
            filterByTags: "Filtrar por etiquetas",
            activeFilters: "Ver filtros ativos",
          },
          emptyQueues: "Não há filas disponíveis",
          emptyTags: "Não há etiquetas disponíveis",
          tabs: {
            groups: "GRUPOS",
            aiAgents: "AGENTES IA",
          },
        },
        filterPanel: {
          title: "Filtros",
          show: "Mostrar",
          hide: "Ocultar",
          departments: "Filas",
          tags: "Etiquetas",
          departmentsWithCount: "Filas ({{count}})",
          tagsWithCount: "Etiquetas ({{count}})",
          clearFilters: "Limpar filtros",
          emptyState: "Não há filtros ativos. Selecione filas ou etiquetas acima.",
        },
        welcome: {
          title: "Bem-vindo ao seu módulo de chat",
          subtitle: "Você pode abrir um novo chat ou aguardar ser atribuído a você",
        },
        aria: {
          resizeTicketsPanel: "Redimensionar painel de tickets",
        },
        mobile: {
          bottomNav: {
            chat: "Chat",
            tickets: "Atendimentos",
          },
        },
        searchResults: {
          searchAria: "Pesquisa",
          searching: "Buscando...",
          resultsFor: 'Resultados para "{{term}}"',
          noResults: "Nenhum resultado encontrado",
          emptySection: "Não há resultados nesta seção.",
          total: "{{count}} no total",
          sections: {
            open: "EM ATENDIMENTO",
            pending: "PENDENTE",
            closed: "FECHADOS",
          },
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        allHeader: "Todos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage: "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        buttons: {
          accept: "Aceitar",
          closed: "Finalizar",
          transfer: "Transferir",
          reopen: "Reabrir",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        selectQueue: "Selecione um departamento",
        selectConnection: "Selecione uma conexão",
        selectChannel: "Por onde iniciar a conversa?",
        channelWhatsApp: "WhatsApp",
        channelTelegram: "Telegram",
        departmentAttention: "Departamento de atendimento",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
        errors: {
          contactRequired: "Selecione um contato para criar o ticket",
          connectionRequired: "Selecione uma conexão",
          queueRequired: "Selecione um departamento",
          channelRequired: "Escolha WhatsApp ou Telegram",
          noChannel: "Este contato não tem WhatsApp nem Telegram",
          noWhatsApp: "Este contato não tem WhatsApp",
          noTelegram: "Este contato não tem Telegram",
        },
      },
      mainDrawer: {
        mobileBar: {
          label: "Atalhos principais",
          dashboard: "Início",
          chats: "Chats",
          negocio: "Negócio",
          groups: "Grupos",
          status: "Estados",
          campaigns: "Envios",
          contacts: "Contatos",
          settings: "Ajustes",
        },
        groups: {
          whatsapp: "Chats",
          dashboard: "Dashboard",
          gruposWA: "Grupos e canais",
          estadosWA: "Estados / Stories",
          mensajes: "Mensagens",
          configuracion: "Configuração",
          flowbuilder: "FlowBuilder",
          utilidades: "Utilitários",
          negocio: "Negócio",
        },
        listItems: {
          dashboard: "Dashboard",
          metrics: "Métricas",
          connections: "Conexões",
          tickets: "Atendimentos",
          gettingStarted: "Primeiros passos",
          quickMessages: "Respostas rápidas",
          kanban: "Kanban",
          todolist: "Tarefas",
          contacts: "Contatos",
          groupsWA: "Lista de grupos/canais",
          newslettersWA: "Canais",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          users: "Usuários",
          userRoles: "Usuários",
          settings: "Configurações",
          helps: "Ajuda",
          messagesAPI: "API",
          appointments: "Agenda",
          negocio: "Negócio",
          negocioResumen: "Resumo",
          negocioCustomers: "Clientes",
          negocioServices: "Serviços",
          negocioSubscriptions: "Cobranças",
          negocioSales: "Movimentos",
          negocioAccounts: "Contas",
          negocioProducts: "Produtos",
          negocioCombos: "Combos",
          negocioSuppliers: "Fornecedores",
          negocioSettings: "Ajustes",
          negocioPayments: "Métodos de pagamento",
          negocioUsers: "Usuários",
          negocioCurrency: "Moeda",
          negocioMessages: "Mensagens",
          negocioReminders: "Lembretes",
          negocioTerms: "Condições de uso",
          negocioRaffle: "Sorteio mensal",
          negocioPoints: "Pontos",
          negocioSectionOperate: "Operação",
          negocioSectionInventory: "Inventário",
          negocioSectionSetup: "Configuração",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          campaignsDispatch: "Envio de mensagens",
          contactLists: "Lista de contatos",
          statusCampaigns: "Estados / Stories",
          campaignShippingReports: "Relatório de envio",
          annoucements: "Informativos",
          chats: "Chat interno",
          localChat: "Chat local",
          financeiro: "Financeiro",
          subscription: "Assinatura",
          files: "Lista de arquivos",
          prompts: "Agentes IA",
          queueIntegration: "Integrações",
          flowbuilders: "Lista de fluxos",
          flowcampaigns: "Campanhas de fluxo",
          dashboardWhatsApp: "Atividade",
          vpsPerformance: "Desempenho VPS",
          satisfactionSurveys: "Pesquisas de satisfação",
          groupCampaigns: "Campanhas de grupos",
          groupCampaignShippingReports: "Relatorio de envio",
          metaHub: "Meta",
          reports: "Relatórios",
        },
        appBar: {
          notRegister: "Sem notificações",
          user: {
            profile: "Perfil",
            logout: "Sair",
            label: "Usuário:",
          },
          tooltips: {
            openDrawer: "Abrir menu",
            closeDrawer: "Fechar menu",
            navigationMenu: "Menu de navegação",
            openNavigationMenu: "Abrir menu de navegação",
            internalChat: "Chat interno",
            help: "Ajuda",
            announcements: "Anúncios",
            whatsappNotifications: "Notificações do WhatsApp",
            settings: "Configurações",
            updateVersion: "Atualizar versão",
            logout: "Sair",
          },
          settingsMenu: {
            lightMode: "Modo claro",
            darkMode: "Modo escuro",
            logs: "Logs",
          },
          pwa: {
            installApp: "Instalar app",
            enableNotifications: "Ativar notificações",
            notificationsOn: "Notificações ativadas",
            bannerInstallTitle: "Instale o WATOOLX",
            bannerInstallBody: "Receba avisos de mensagens novas mesmo com o painel fechado.",
            bannerNotifyTitle: "Ative as notificações",
            bannerNotifyBody: "Assim você fica por dentro de tickets e mensagens novas, também no app instalado.",
            bannerInstall: "Instalar",
            bannerEnable: "Ativar",
            bannerLater: "Agora não",
            iosTitle: "Adicionar à tela inicial",
            iosBody: "No Safari: toque em Compartilhar e escolha Adicionar à Tela de Início. Abra o app pelo ícone e ative as notificações.",
            gotIt: "Entendi",
            permissionDenied: "As notificações estão bloqueadas. Ative-as nas configurações do navegador ou do telefone.",
          },
          versionLong: "VERSÃO {{version}}",
          versionShort: "V{{version}}",
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      reports: {
        title: "Relatórios de Atendimentos",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
        },
        searchPlaceholder: "Pesquisar...",
      },
      files: {
        title: "Lista de arquivos",
        adminTitle: "Administrador de arquivos",
        searchPlaceholder: "Buscar listas de arquivos...",
        newList: "Nova lista de arquivos",
        listCount: "{{count}} listas",
        table: {
          name: "Nome da lista",
          description: "Descrição",
          fileCount: "Quantidade de arquivos",
          createdAt: "Data de criação",
          actions: "Ações",
        },
        noDescription: "Sem descrição",
        filesInList: "{{count}} arquivos",
        tooltips: { editList: "Editar lista", deleteList: "Excluir lista" },
        contacts: "Contatos",
        actions: "Ação",
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      messagesAPI: {
        title: "API de mensagens WhatsApp",
        documentation: {
          title: "Documentação de envio de mensagens",
          methods: "Métodos de envio",
          instructions: "Instruções",
          importantNotes: "Observações importantes",
          textMessages: "Mensagens de texto",
          mediaMessages: "Mensagens multimídia",
          endpoint: "Endpoint",
          method: "Método",
          headers: "Headers",
          body: "Body",
          formData: "FormData",
          testSend: "Teste de envio",
          send: "Enviar",
        },
        instructions: {
          tokenRequired:
            "Antes de enviar mensagens, registre o token vinculado à conexão que enviará as mensagens. Acesse Conexões, edite a conexão e insira o token no campo correspondente.",
          numberFormat: "O número não deve ter máscara nem caracteres especiais e deve conter:",
          countryCode: "Código do país",
          areaCode: "DDD",
          number: "Número",
        },
        importantInfo: {
          title: "Informação importante",
          tokenLabel: "Token obrigatório",
          tokenBody: "Registre um token vinculado à conexão que enviará as mensagens",
          formatLabel: "Formato do número",
          formatBody: "Código do país + DDD + número (sem caracteres especiais)",
          exampleLabel: "Exemplo",
          exampleBody: "51959858768 (Peru: 51, DDD: 959, Número: 858768)",
          channelsLabel: "Qual conexão usar",
          channelsBody: "Texto, multimídia e enquetes: token do WhatsApp. Grupos: token do WhatsApp ou do Telegram. Canais @newsletter: só WhatsApp. Estados e histórias: token do WhatsApp ou do Telegram. Não abre conversas.",
        },
        chips: {
          endpoint: "ENDPOINT",
          method: "MÉTODO",
          headers: "HEADERS",
          upTo100mb: "ATÉ 100MB",
        },
        common: {
          apiInfoTitle: "Informação da API",
          testSendTitle: "Teste de envio",
          bodyJson: "Body (JSON):",
          formData: "FormData:",
        },
        section1: {
          title: "1. Mensagens de texto",
          intro: "Envie mensagens de texto simples pela API do WhatsApp Business.",
          bodySnippet: `{ "number": "51959858768", "body": "Sua mensagem" }`,
        },
        section2: {
          title: "2. Mensagens multimídia",
          intro:
            "Envie arquivos multimídia (imagens, vídeos, documentos, áudio) pela API do WhatsApp Business.",
          maxCapacity: "Capacidade máxima:",
          maxCapacityBody: "Arquivos de até 100 MB",
          formDataNumber: "number:",
          formDataNumberEx: "51959858768",
          formDataMedias: "medias:",
          formDataMediasEx: "arquivo",
          formDataBody: "body:",
          formDataBodyEx: "legenda opcional (texto de acompanhamento)",
          fileTypesTitle: "Tipos de arquivo suportados:",
          images: "Imagens:",
          imagesEx: "JPG, PNG, GIF (até 5MB)",
          videos: "Vídeos:",
          videosEx: "MP4, AVI, MOV (até 16MB)",
          documents: "Documentos:",
          documentsEx: "PDF, DOC, XLS, PPT (até 100MB)",
          audio: "Áudio:",
          audioEx: "MP3, WAV, OGG (até 16MB)",
        },
        section3: {
          title: "3. Mensagens para grupos",
          intro: "Envie texto para um grupo. Com token do WhatsApp use o ID do grupo. Com token do Telegram use o ID do grupo ou canal dessa conta.",
          bodySnippet: `{ "number": "12036312345678901234", "body": "Sua mensagem" }`,
          groupNote: "Nota:",
          groupNoteBody: "No WhatsApp é adicionado @g.us. No Telegram o ID é usado como está e não abre um chat privado.",
        },
        section4: {
          title: "4. Multimídia para grupos",
          intro: "Envie um arquivo para um grupo do WhatsApp ou, com o token do Telegram, para um grupo ou canal do Telegram.",
          formDataNumberLi: "ID do grupo (ex.: 12036312345678901234)",
          formDataMediasLi: "arquivo multimídia",
        },
        sectionChannel: {
          title: "5. Canais WhatsApp: Texto, Multimídia e Enquetes",
          intro:
            "Publique conteúdo em um Canal do WhatsApp administrado pela conexão autenticada. O mesmo endpoint aceita texto, um arquivo multimídia ou uma enquete.",
          destinationTitle: "Destino:",
          destinationBody:
            "newsletterJid, jid, link ou channelLink. Recomenda-se usar o JID terminado em @newsletter.",
          securityTitle: "Autorização:",
          securityBody:
            "Bearer token da conexão administradora. Ela deve estar CONNECTED e ter função ADMIN ou OWNER no canal.",
          textTitle: "Publicar texto",
          textCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "body=Publicação do canal"`,
          mediaTitle: "Publicar multimídia com texto opcional",
          mediaCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "body=Texto opcional" \\
  -F "medias=@/caminho/arquivo.jpg"`,
          pollTitle: "Publicar enquete",
          pollCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "type=poll" \\
  -F "question=Qual conteúdo você prefere?" \\
  -F 'options=["Tutoriais","Notícias","Ofertas"]' \\
  -F "selectableCount=1"`,
          responseNote:
            "HTTP 200 significa publicação verificada. HTTP 202 significa que foi enviada ao socket, mas não pôde ser confirmada por ACK, evento ou leitura posterior. Verifique success, publishedVerified, verification, serverId e messageId.",
          limitsNote:
            "Somente WhatsApp. Um canal do Telegram é publicado no envio para grupos, com o token do Telegram. Somente um arquivo é processado por solicitação. Uma enquete não aceita multimídia.",
        },
        sectionStatus: {
          title: "Estados e histórias",
          intro: "Publica na hora no Estado do WhatsApp ou numa história do Telegram. O token escolhe a conexão. Não envia mensagem de chat.",
          whatsappTitle: "WhatsApp",
          whatsappBody: "Texto, foto, vídeo ou áudio. targetType all publica em lotes de 50 para os contatos com conversa nessa linha. O WhatsApp mostra para quem salvou o número. targetType contacts limita a lista com contactIds.",
          telegramTitle: "Telegram",
          telegramBody: "Foto ou vídeo obrigatório. O texto é a legenda. Publica uma história visível para os contatos da conta. Só texto responde 400.",
          fieldsTitle: "Campos",
          fieldsBody: "name (opcional), targetType (all ou contacts), contactIds (1,2,3 ou [1,2,3]), body ou message, media, medias ou file.",
          curl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN_DA_CONEXAO" \\
  -F "targetType=all" \\
  -F "body=Conteúdo do estado" \\
  -F "media=@/caminho/imagem.jpg"`,
          testNote: "200: publicado. 400: falta conteúdo ou, no Telegram, a foto ou o vídeo. 401: token inválido. 409: a conexão não está conectada.",
        },
        sectionPoll: {
          title: "6. Enquetes, Perguntas e Questionários para Contatos",
          intro:
            "Envie uma enquete nativa do WhatsApp para um contato. Uma pergunta ou questionário é representado por uma enquete de escolha única ou múltipla.",
          bodySnippet: `{
  "type": "poll",
  "number": "51959858768",
  "question": "Qual horário você prefere?",
  "options": ["Manhã", "Tarde", "Noite"],
  "selectableCount": 1
}`,
          fieldsTitle: "Campos aceitos:",
          typeField:
            "poll. Também são aceitos survey, encuesta, question, pregunta, quiz e cuestionario.",
          numberField: "número do contato com código do país e sem símbolos.",
          questionField:
            "texto da pergunta. question tem prioridade; body funciona como alias.",
          optionsField:
            "mínimo de 2 opções, como array JSON ou texto separado por vírgulas/quebras de linha.",
          selectableCountField:
            "1 para escolha única; 0 para múltipla escolha; também aceita um inteiro até o total de opções.",
          quizNote:
            "Um questionário com várias perguntas exige várias solicitações, uma enquete por pergunta. A API não calcula respostas corretas ou pontuação.",
          validationNote:
            "Respostas: 200 quando enviado; 400 para pergunta/opções inválidas; 401 para token inválido; erro de conexão se o WhatsApp estiver offline. Não anexe multimídia a uma enquete.",
        },
        forms: {
          tokenRegistered: "Token cadastrado",
          tokenRegisteredReq: "Token cadastrado *",
          tokenPlaceholder: "Digite seu token aqui",
          number: "Número",
          numberReq: "Número *",
          message: "Mensagem",
          messageReq: "Mensagem *",
          messageOptional: "Mensagem (opcional)",
          messageOptionalPlaceholder: "Legenda opcional para acompanhar o arquivo...",
          messagePlaceholder: "Digite sua mensagem aqui",
          numberPlaceholder: "51980795094",
          fileName: "Nome do arquivo",
          sendMessage: "ENVIAR MENSAGEM",
          sendMedia: "Enviar multimídia",
          selectFile: "Selecionar arquivo",
          clickUploadHint: "Clique para selecionar um arquivo multimídia",
          fileSize: "Tamanho:",
          groupId: "ID do grupo *",
          groupIdHelper: "ID do grupo sem @g.us (ex.: 12036312345678901234)",
          groupIdHelperShort: "ID do grupo sem @g.us",
          sendToGroup: "Enviar ao grupo",
          sendMediaToGroup: "Enviar multimídia ao grupo",
          pollQuestion: "Pergunta *",
          pollOptions: "Opções *",
          pollOptionsHelper: "Digite uma opção por linha ou separe por vírgulas. Mínimo 2.",
          pollSelectionMode: "Modo de seleção",
          pollSingleChoice: "Escolha única",
          pollMultipleChoice: "Múltipla escolha",
          sendPoll: "Enviar enquete",
          whatsappId: "ID da conexão WhatsApp *",
          channelJid: "JID ou link do canal *",
          channelMode: "Tipo de publicação",
          channelText: "Texto",
          channelMedia: "Multimídia",
          channelPoll: "Enquete",
          sendChannel: "Publicar no canal",
        },
        fileSize: {
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
        apiInfo: {
          textMessageInfo: "Abaixo as informações necessárias para envio de mensagens de texto:",
          mediaMessageInfo: "Abaixo as informações necessárias para envio de mensagens multimídia:",
          authorization: "Authorization (Bearer token) e Content-Type (application/json)",
          multipartForm: "Authorization (Bearer token) e Content-Type (multipart/form-data)",
          exampleBody: '{ "number": "51959858768", "body": "Sua mensagem" }',
          exampleNumber: "51959858768",
          exampleFile: "arquivo",
        },
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        section5: {
          title: "7. API externa — N8N / TypeBot",
          intro:
            "Endpoints para integrações externas (N8N, TypeBot, etc.). Use o mesmo token do WhatsApp da API de mensagens. As respostas incluem o objeto variables compatível com TypeBot/N8N.",
          baseUrl: "URL base:",
          headersLine: "Headers:",
          getTicketByNumber: "GET — Ticket por número",
          getTicketById: "GET — Ticket por ID",
          getUsers: "GET — Usuários/agentes",
          getTags: "GET — Etiquetas",
          putAssignTag: "PUT — Atribuir etiqueta",
          putUpdateTicket: "PUT — Atualizar ticket",
          bodyLabel: "Body:",
          altPostTitle: "Alternativas POST (body ou query para Typebot):",
          postTicketBody1:
            'POST {{base}}/ticket — Body: { "atendimento": 1223 } ou { "number": "51980795334" }',
          postTicketBody2: "POST {{base}}/ticket?number={{telefono}} — variáveis na URL (Typebot)",
          postTicketBody3:
            "POST {{base}}/ticket/tag?atendimento={{atendimento}}&tagId=6 — query params",
          postTicketBody4:
            'POST {{base}}/ticket — Body: { "atendimento": 1223, "status": "open", "userId": 1 } (atualizar)',
          postUsersTags: "POST {{base}}/users — POST {{base}}/tags",
          variablesObjectTitle: "Objeto variables (respostas ticket):",
          variablesList:
            "atendimento, nome, numero, status, canal, grupo, user, userEmail, queue, tags, whatsappNumber, whatsappName",
          typebotGuideTitle: "Guia Typebot (fluxo validado):",
          typebotStep1: "Input: perguntar número, salvar na variável telefono",
          typebotStep2: "HTTP Request: POST /ticket?number={{telefono}} (use chaves para variável)",
          typebotStep3: "Headers: Authorization = Bearer token",
          typebotStep4: "Salvar em variables: data.variables.numero, nome, atendimento",
          typebotStep5: "Text: exibir numero, nome, atendimento",
          seeGuide: "Ver guia 0275 para detalhe completo.",
        },
        messages: {
          success: "Mensagem enviada com sucesso",
          successMedia: "Mensagem multimídia enviada com sucesso",
          successGroup: "Mensagem enviada ao grupo com sucesso",
          successGroupMedia: "Mensagem multimídia enviada ao grupo com sucesso",
          successPoll: "Enquete enviada com sucesso",
          pollOptionsError: "A enquete requer pelo menos 2 opções válidas",
          successChannel: "Conteúdo publicado e verificado no canal",
          channelNotVerified: "A publicação foi enviada, mas não pôde ser verificada",
          groupSendError: "Erro ao enviar mensagem ao grupo",
          groupMediaError: "Erro ao enviar multimídia ao grupo",
          noPermission: "Esta empresa não tem permissão para acessar esta página. Redirecionando…",
        },
        errors: {
          backendUrlNotConfigured: "REACT_APP_BACKEND_URL não está configurado",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        whatsappDisconnected: {
          title: "Sem conexões WhatsApp",
          body: "Não há conexões ativas. Configure ou reconecte suas conexões WhatsApp para continuar.",
          reconnect: "RECONECTAR AGORA",
          close: "Fechar",
        },
      },
      whatsappConnectionsMenu: {
        loadingConnections: "Carregando conexões…",
        tooltipNoConnections: "Sem conexões WhatsApp — clique para ver detalhes",
        tooltipSomeConnected: "Pelo menos uma conexão ativa — clique para ver a lista",
        tooltipNoneActive: "Nenhuma conexão ativa — clique para ver a lista",
        ariaLabel: "Status das conexões WhatsApp",
        menuTitle: "Conexões WhatsApp",
        loading: "Carregando…",
        noneConfigured: "Nenhuma conexão configurada",
        connectionFallback: "Conexão #{{id}}",
        manage: "Gerenciar conexões…",
        status: {
          connected: "Conectado",
          opening: "Conectando…",
          disconnected: "Desconectado",
        },
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        searchFieldPlaceholder: "Pesquisar respostas rápidas...",
        noAttachment: "Sem anexo",
        noFile: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          addReply: "Adicionar resposta",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Global",
          shortcodeHeader: "ATALHO",
          messageHeader: "RESPOSTA",
          mediaNameHeader: "NOME DO ARQUIVO",
          statusHeader: "ESTADO",
          actionsHeader: "AÇÕES",
        },
        tooltips: {
          openAttachment: "Clique para abrir o arquivo",
          edit: "Editar resposta rápida",
          delete: "Excluir resposta rápida",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        tooltipContactVars: "Variáveis de contato",
        tooltipSystemVars: "Variáveis do sistema",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitle: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          aiAgent: "Agente IA",
          contactList: "Lista de Contatos",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Lista de Tags",
            fileList: "Lista de Arquivos",
          },
          includeColdContacts: "Incluir contatos frios",
          includeColdContactsHint:
            "Ativado: envia para toda a lista. Desativado: só para números que já escreveram (mensagem de entrada).",
          poll: {
            toggle: "Adicionar enquete do WhatsApp",
            hint: "É enviada logo após a mensagem da campanha. Os votos são registrados e aparecem no relatório da campanha.",
            question: "Pergunta",
            questionHint: "Máximo 255 caracteres. Use {{name}} para o nome do contato.",
            option: "Opção",
            addOption: "Adicionar opção",
            multiple: "Permitir várias respostas",
            results: "Resultados da enquete",
            sent: "Enquetes enviadas",
            voters: "Contatos que votaram",
            votes: "votos",
            noVotes: "Ainda não há votos.",
            voterList: "Detalhe dos votos",
          },
          ai: {
            wizardQuestion:
              "Deseja usar Inteligência Artificial dinâmica nas mensagens desta campanha?",
            wizardHelp:
              "Com IA, cada contato pode receber uma mensagem personalizada conforme o agente escolhido e o texto base (semente) que você digitar. Sem IA, o disparo segue como sempre. Com IA é obrigatório configurar etiquetas ante resposta.",
            choiceNo: "Não — modo clássico (Msg. 1–5 e anexos como antes)",
            choiceYes: "Sim — IA dinâmica (semente única + agente Prompt)",
            continue: "Continuar",
            modeLabel: "Modo de disparo em massa",
            modeClassic: "Clássico (sem IA no texto enviado)",
            modeAi: "IA dinâmica (mensagem única adaptada por contato)",
            promptAgent: "Agente IA (lista / legado)",
            promptAgentSend: "Agente IA (personaliza cada disparo)",
            replyPromptAgent: "Agente IA (quando o contato responder)",
            ariaAiEnvironment: "Campanha com assistente de inteligência artificial",
            promptPlaceholder: "Selecione um agente…",
            promptPlaceholderSend: "Selecione o agente para o disparo em massa…",
            promptPlaceholderReply: "Selecione o agente para ante resposta do contato…",
            seedBanner:
              "IA generativa ativa: serão criadas versões únicas da mensagem por destinatário; no servidor há variação aleatória nos intervalos de envio.",
            seedLabel: "Mensagem semente (base)",
            intervalHint:
              "Com IA dinâmica, o sistema aplica variação aleatória aos tempos de envio sobre os intervalos definidos aqui.",
            tagMandatoryHint:
              "Com IA dinâmica, a etiqueta ante resposta é obrigatória: ative e escolha qual aplicar.",
            autoTagForced: "Ativado (obrigatório com IA dinâmica)",
            responderTab: "RESPONDER",
            responderTitle: "Ante resposta do contato",
            responderBanner:
              "Escolha o agente a ser usado quando um contato responde após esta campanha. É independente do que personaliza cada mensagem enviada.",
            attachFileAria: "Anexar arquivo",
            errors: {
              promptSendRequired: "Selecione o agente IA para o disparo em massa.",
              replyPromptRequired: "Selecione o agente IA para ante resposta (aba RESPONDER).",
            },
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      announcements: {
        active: "Ativo",
        inactive: "Inativo",
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        toasts: {
          deleted: "Fila excluída com sucesso.",
        },
        table: {
          id: "ID",
          department: "Fila",
          name: "Nome",
          color: "Cor",
          automation: "Automação",
          greeting: "Mensagem de saudação",
          actions: "Ações",
          orderQueue: "Ordenação da fila (bot)",
        },
        automationLabels: {
          flowbuilder: "FLOWBUILDER",
          prompt: "PROMPT",
          integration: "INTEGRAÇÃO",
          chatbot: "CHATBOT",
          none: "Sem automação",
        },
        placeholders: {
          noGreeting: "Sem mensagem",
        },
        tooltips: {
          editQueue: "Editar fila",
          deleteQueue: "Excluir fila",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueOptions: {
        title: "Chatbot com menus de opções",
        subtitle:
          "Defina os botões que o contato verá no chat (menu em níveis). Não é um assistente de texto livre: o cliente navega tocando nas opções. Use «Adicionar» para cada item do menu.",
        add: "Adicionar",
        placeholder: {
          title: "Título da opção",
          message: "Texto da opção",
        },
        undefinedTitle: "Título não definido",
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      users: {
        title: "Usuários",
        table: {
          id: "ID",
          name: "Nome",
          status: "Status",
          email: "Email",
          profile: "Perfil",
          department: "Departamento",
          lastConnection: "Última conexão",
          lastConnectionNow: "Agora online",
          connected: "Conectada",
          disconnected: "Desconectada",
          actions: "Ações",
        },
        profiles: {
          admin: "Admin",
          supervisor: "Supervisor",
          user: "Agente",
        },
        status: {
          online: "Usuários online",
          offline: "Usuários offline",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      helps: {
        title: "Central de Ajuda",
        form: {
          title: "Título",
          videoCode: "URL do vídeo (YouTube)",
          description: "Descrição",
        },
        table: {
          title: "Título",
          description: "Descrição",
          video: "Vídeo",
          preview: "Vista",
          content: "Conteúdo",
          source: "Fonte",
          visibility: "Visibilidade",
          actions: "Ações",
        },
        library: {
          title: "Biblioteca de vídeos",
          noDescription: "Sem descrição",
        },
        summary: {
          total: "Total",
          visible: "Visíveis",
          hidden: "Ocultos",
          types: "YT/Ext",
        },
        videoTypes: {
          youtube: "YouTube",
          external: "Externo",
          unknown: "Vídeo",
        },
        buttons: {
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
          saving: "A guardar...",
        },
        formTitle: {
          edit: "Editar vídeo de ajuda",
          create: "Criar novo vídeo de ajuda",
        },
        sectionVideo: "Informação do vídeo de ajuda",
        placeholders: {
          video: "https://youtu.be/6FdRJTw46qI ou https://seudominio.com/video.mp4",
          thumbnail: "https://seudominio.com/thumbnails/video.jpg",
        },
        helpers: {
          youtubeDetected: "✅ Vídeo do YouTube detetado",
          externalDetected: "✅ Vídeo externo detetado",
          pasteHint:
            "Cole o URL do YouTube ou um URL externo de vídeo (ex.: https://seudominio.com/video.mp4)",
        },
        thumbnail: {
          label: "URL da miniatura (opcional)",
          hint: "URL opcional da miniatura. Se vazio, usa miniatura do YouTube ou um marcador.",
        },
        grid: {
          emptyTitle: "Não há vídeos de ajuda registados",
          emptySubtitle: "Crie o seu primeiro vídeo de ajuda para começar",
        },
        tooltips: {
          editRow: "Editar vídeo de ajuda",
          hide: "Ocultar este vídeo das empresas",
          show: "Mostrar este vídeo às empresas",
          moveUp: "Mover vídeo para cima",
          moveDown: "Mover vídeo para baixo",
        },
        visibility: {
          visible: "Visível",
          hidden: "Oculto",
        },
        validation: {
          invalidVideoInput:
            "URL de vídeo inválida. Indique um URL do YouTube ou um URL externo válido (ex.: https://seudominio.com/video.mp4)",
          processFailed: "Não foi possível processar o URL do vídeo",
          urlInvalid: "URL inválida. Deve começar por http:// ou https://",
          urlExtensionHint:
            "O URL não tem extensão de vídeo. Certifique-se de que o servidor devolve o Content-Type correcto.",
        },
        toast: {
          youtubeDetected: "Vídeo do YouTube detetado: {{code}}",
          externalDetected: "Vídeo externo detetado e guardado",
        },
        messages: {
          loadError: "Não foi possível carregar os itens",
          saveSuccess: "Operação concluída com sucesso!",
          saveError: "Não foi possível salvar. Verifique duplicidade ou campos incompletos.",
          deleteSuccess: "Operação concluída com sucesso!",
          deleteError: "Não foi possível concluir a operação",
          hideSuccess: "Vídeo ocultado das empresas",
          showSuccess: "Vídeo visível para as empresas",
          visibilityError: "Não foi possível atualizar a visibilidade do vídeo",
          orderSuccess: "Ordem dos vídeos atualizada",
          orderError: "Não foi possível atualizar a ordem dos vídeos",
          deleteTitle: "Exclusão de registro",
          deleteMessage: "Deseja realmente excluir este registro?",
          videoUnavailable: "Vídeo indisponível",
          videoLoadError: "Não foi possível carregar o vídeo",
          videoLoadHint: "O vídeo pode estar indisponível ou a URL inacessível neste domínio.",
          videoCorsHint:
            "Verifique se o servidor permite acesso público (CORS) e se a URL está correta.",
          youtubeError: "Erro ao carregar vídeo do YouTube",
          videoUrlError: "Erro ao carregar vídeo. Verifique URL e formato.",
          videoNotSupported: "Seu navegador não suporta vídeo.",
        },
      },
      schedules: {
        title: "Agendamentos",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
          deleteAllMessage: "Tem certeza que deseja deletar todas as Tags?",
          deleteAllTitle: "Deletar Todos",
        },
        table: {
          name: "Nome",
          tagName: "Nome da etiqueta",
          color: "Cor",
          tickets: "Registros Tagdos",
          taggedTickets: "Tickets etiquetados",
          kanban: "Kanban",
          origin: "Origem",
          actions: "Ações",
        },
        kanbanActive: "ATIVO",
        kanbanInactive: "INATIVO",
        originProfile: "Por perfil",
        originManual: "Manual",
        readOnly: "Somente leitura",
        profileTagTitle: "Coluna Kanban criada com a Agenda ativa. Somente leitura.",
        manualTagTitle: "Etiqueta criada manualmente",
        readOnlyHint:
          "Colunas de perfil não são editadas aqui. Altere o perfil em Agenda > Configuração.",
        tooltips: { editTag: "Editar etiqueta", deleteTag: "Excluir etiqueta" },
        buttons: {
          add: "Nova Tag",
          deleteAll: "Deletar Todas",
        },
        toasts: {
          deletedAll: "Todas Tags excluídas com sucesso!",
          deleted: "Tag excluído com sucesso.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        error: "Não foi possível guardar as configurações.",
        title: "Configurações",
        schedules: {
          success: "Horários guardados com sucesso.",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
        tabs: {
          options: "Opções",
          schedules: "Horários",
          version: "Versões",
          smtp: "SMTP",
          alerts: "Alertas",
          subscriptions: "Assinaturas",
          logo: "Web",
          companies: "Empresas",
          registerCompany: "Registrar empresa",
          plans: "Planos",
          help: "Ajuda",
          performance: "Desempenho do servidor",
        },
        options: {
          userRating: "Avaliação do usuário",
          userRatingDesc: "Permite que os usuários avaliem o atendimento",
          userRatingMessageText: "Mensagem de pedido de avaliação",
          userRatingMessageTextDesc:
            "Enviada ao fechar tíquete (junto ao texto da conexão WhatsApp se houver). Máx. 500 caracteres. Mesmas regras da mensagem de chamadas: não pode ficar vazia ao guardar.",
          userRatingMessageTextPlaceholder: "Escreva de 1 a 3 para avaliar…",
          sendGreetingAcceptedMessageText: "Texto de saudação ao aceitar (menu)",
          sendGreetingAcceptedMessageTextDesc:
            "Usado como saudação do menu de opções quando o departamento não tem mensagem própria. Mustache: {{name}}, {{firstName}}, etc.",
          sendGreetingAcceptedMessageTextPlaceholder: "Olá {{name}}! Obrigado por contactar…",
          transferTicketMessageText: "Mensagem ao transferir de departamento",
          transferTicketMessageTextDesc:
            "Só é enviada se «Enviar mensagem de transferência» estiver ativa. Variáveis: {{name}}, {{firstName}} e {queueName} ou {{queueName}} para o destino.",
          transferTicketMessageTextPlaceholder: "Olá {{name}}! Foi transferido…",
          greetingOneQueueMessageText: "Saudação com um só departamento",
          greetingOneQueueMessageTextDesc:
            "Substitui ou complementa a saudação da conexão quando há só uma fila e a opção está ativa. Mustache: {{name}}, {{firstName}}, etc.",
          greetingOneQueueMessageTextPlaceholder: "Olá {{name}}! Obrigado por escrever…",
          scheduleType: "Tipo de horário",
          ignoreGroupMessages: "Ignorar mensagens de grupo",
          acceptCall: "Aceitar chamadas",
          sendCallAutoMessage: "Enviar mensagem automática com chamadas desativadas",
          sendCallAutoMessageDesc:
            "Quando ativo, envia mensagem automática com chamadas desativadas",
          callAutoMessage: "Mensagem automática de chamadas",
          callAutoMessageDesc:
            "Personalize a mensagem enviada automaticamente com chamadas desativadas",
          callAutoMessagePlaceholder: "Escreva a mensagem automática (máx. 500 caracteres)",
          restoreDefault: "Restaurar predefinição",
          preview: "Pré-visualização",
          chatbotType: "Tipo de chatbot",
          sendGreetingAccepted: "Enviar saudação ao aceitar",
          sendGreetingAcceptedDesc: "Envia saudação automática ao aceitar tíquete",
          sendTransferMessage: "Enviar mensagem de transferência",
          sendTransferMessageDesc: "Envia mensagem ao transferir entre departamentos",
          removeTagsOnCloseTicket: "Remover etiquetas ao fechar",
          removeTagsOnCloseTicketDesc:
            "Se ativo, ao fechar remove todas as etiquetas e pede confirmação antes de fechar",
          sendTicketCloseMessage: "Mensagem ao fechar tíquete",
          sendTicketCloseMessageDesc:
            "Envia WhatsApp ao cliente ao fechar (não para grupos). Use {nroticket} para o número do tíquete",
          ticketCloseMessageText: "Texto da mensagem ao fechar",
          ticketCloseMessageTextDesc:
            "Mesmas regras da mensagem automática de chamadas: texto obrigatório (máx. 500), editável com «Restaurar predefinição». {nroticket} = ID do tíquete.",
          ticketCloseMessageTextPlaceholder:
            "💬⚙️ *Tíquete:* {nroticket} foi fechado. O bot volta em *5 minutos*",
          sendGreetingOneQueue: "Enviar saudação com um departamento",
          sendGreetingOneQueueDesc: "Mostra saudação quando há só uma fila",
          globalSettings: "Configurações globais",
          registrationAllowed: "Registo permitido",
          registrationVisible: "Registo visível",
          trialTime: "Período de teste",
          mainSettings: "Configurações principais",
          messagingSettings: "Configurações de mensagens",
          customerMessageLocale: "Idioma das mensagens automáticas ao cliente (WhatsApp)",
          customerMessageLocaleDesc:
            "Idioma de saudações, transferências, modelos e textos automáticos no WhatsApp. Independente do idioma do painel.",
          scheduleTypeDesc: "Define o tipo de horário de atendimento",
          ignoreGroupMessagesDesc: "Ignora grupos do WhatsApp",
          chatbotTypeDesc: "Tipo de chatbot para respostas automáticas",
          internalSignature: "Assinaturas internas",
          internalSignatureDesc: "Mostra o nome do utilizador em cada mensagem (só interno)",
          validateWhatsAppNumbers: "Validar números WhatsApp",
          validateWhatsAppNumbersDesc:
            "Na importação, verifica se o número existe no WhatsApp. Inválidos não são enviados. Se o WhatsApp não responder, o contato é guardado e a campanha tenta mesmo assim.",
          timezoneForCampaigns: "Fuso horário para campanhas",
          timezoneForCampaignsDesc: "Selecione o fuso para campanhas em massa",
          timezone: "Fuso horário",
          callAutoMessageMaxLength: "A mensagem não pode exceder 500 caracteres",
          callAutoMessageSaveError: "Erro ao guardar a mensagem",
          characters: "caracteres",
          registrationAllowedDesc: "Permite registo de novos utilizadores",
          registrationVisibleDesc: "Mostra o formulário de registo publicamente",
          trialTimeDesc: "Dias de teste para novos utilizadores",
          day: "dia",
          days: "dias",
          additionalSettings: "Configurações adicionais",
          hubNotificaMeToken: "Hub NotificaMe — token da conta",
          hubNotificaMeTokenDesc: "Token de 36 caracteres para integração",
          hubNotificaMeTokenLabel: "Token da conta",
          hubNotificaMeTokenHelper: "Deve ter exatamente 36 caracteres",
          webInfo: "Info web",
          websiteTitle: "Título do site",
          websiteTitleDesc: "Título na aba do navegador e resultados de pesquisa",
          websiteDescription: "Descrição do site",
          websiteDescriptionDesc: "Descrição em pesquisa e redes sociais",
          websiteKeyword: "Palavra-chave do site",
          websiteKeywordDesc: "Principais palavras-chave para SEO",
          companyName: "Nome da empresa",
          companyNameDesc: "Nome no copyright do login",
          companyNameCopyright: "Nome da empresa (copyright)",
          logos: "Logos",
          exampleCliqueaCRM: "Exemplo: Cliquea CRM",
          exampleAutomatiza: "Exemplo: Automatize, conecte e venda mais!",
          exampleWhatsAppAPI: "Exemplo: WHATSAPP API",
          exampleWatoolx: "Exemplo: watoolx.com",
          localeEs: "Espanhol",
          localeEn: "English",
          localePt: "Português",
          loadingTimezones: "A carregar fusos horários…",
          timezoneQuickPeru: "Peru (America/Lima)",
          timezoneQuickColombia: "Colômbia (America/Bogota)",
          ariaSectionMain: "Configurações principais",
          ariaSectionMessaging: "Configurações de mensagens",
        },
        states: {
          disabled: "Desativado",
          enabled: "Ativado",
          activated: "Ativado",
          deactivated: "Desativado",
          accept: "Aceitar",
          notAccept: "Não aceitar",
          text: "Texto",
          updating: "A atualizar...",
          yes: "Sim",
          no: "Não",
          queue: "Departamento",
          company: "Empresa",
        },
        versionPage: {
          loading: "A carregar informação de versão…",
          title: "Informação de versão do sistema",
          ariaVersion: "Versão",
          currentVersion: "Versão atual",
          changelogChip: "changelog {{version}}",
          releaseDateChangelog: "Data de release (CHANGELOG):",
          changeType: "Tipo de alteração",
          gitDateChip: "Data via Git",
          releaseSummary: "Resumo do último release",
          changesCount: "{{count}} alterações",
          frontendVersion: "Versão front-end",
          apiVersion: "Versão API (pacote backend)",
          baseWhaticket: "Base Whaticket:",
          lastUpdate: "Última atualização",
          semanticFooter: "Versionamento semântico ativo",
          fullHistory: "Ver histórico completo →",
          na: "N/D",
        },
        subscriptionsPayment: {
          title: "Métodos de pagamento",
          intro: "Configure credenciais PayPal e Stripe para pagamentos recorrentes. ",
          introNote: "Nota: após guardar, reinicie o servidor backend para aplicar.",
          saving: "A guardar…",
          sectionPaypal: "PayPal",
          sectionStripe: "Stripe",
          sectionCurrency: "Moeda",
          sectionManual: "Pagamento manual",
          paypalClientIdLabel: "ID de cliente PayPal",
          paypalClientIdDesc: "ID de cliente da aplicação PayPal",
          paypalClientIdField: "PayPal Client ID",
          paypalClientIdHelper: "Exemplo: AQkquBDf1zctJOWLbrloE4zQnlX4rQvBfhXUZHX96zShVqSB2ikbkGg",
          paypalSecretLabel: "Segredo do cliente PayPal",
          paypalSecretDesc: "Segredo da aplicação PayPal",
          paypalSecretField: "PayPal Client Secret",
          paypalSecretHelper: "Segredo da sua aplicação PayPal",
          paypalModeLabel: "Modo PayPal",
          paypalModeDesc: "Sandbox (testes) ou live (produção)",
          modeField: "Modo",
          modeSandbox: "Sandbox (testes)",
          modeLive: "Live (produção)",
          stripeKeyLabel: "Chave secreta Stripe",
          stripeKeyDesc: "Chave secreta da conta Stripe (sk_test_… ou sk_live_…)",
          stripeKeyField: "Stripe Secret Key",
          stripeKeyHelper: "Exemplo: sk_test_51AbCdEf…",
          stripeWebhookLabel: "Webhook secret Stripe",
          stripeWebhookDesc: "Segredo do webhook para verificar eventos (whsec_…)",
          stripeWebhookField: "Stripe Webhook Secret",
          stripeWebhookHelper: "Exemplo: whsec_1234567890abcdef",
          currencyLabel: "Moeda preferida",
          currencyDesc: "Moeda em planos e faturas",
          currencyField: "Moeda",
          currencyUSD: "USD — Dólar ($)",
          currencyEUR: "EUR — Euro (€)",
          currencyGBP: "GBP — Libra (£)",
          currencyBRL: "BRL — Real (R$)",
          currencyMXN: "MXN — Peso mexicano ($)",
          currencyARS: "ARS — Peso argentino ($)",
          currencyCLP: "CLP — Peso chileno ($)",
          currencyCOP: "COP — Peso colombiano ($)",
          currencyPEN: "PEN — Sol peruano (S/)",
          toastPaypalId: "PayPal Client ID guardado",
          toastPaypalSecret: "PayPal Client Secret guardado",
          toastPaypalMode: "Modo PayPal atualizado",
          toastStripeKey: "Stripe Secret Key guardado",
          toastStripeWebhook: "Stripe Webhook Secret guardado",
          toastCurrency: "Moeda atualizada",
          manualIntro:
            "Se não houver gateway online configurado, as empresas verão estes dados para coordenar o pagamento manual.",
          manualEmailLabel: "Email de faturação",
          manualWhatsappLabel: "WhatsApp de faturação",
          manualInstructionsLabel: "Instruções de pagamento manual",
          manualInstructionsPlaceholder:
            "Envie-nos uma mensagem com o plano desejado e enviaremos os dados de pagamento.",
          toastManualEmail: "Email de pagamento manual guardado",
          toastManualWhatsapp: "WhatsApp de pagamento manual guardado",
          toastManualInstructions: "Instruções de pagamento manual guardadas",
        },
        smtpManager: {
          pageTitle: "SMTP e modelos",
          tabSmtp: "Configurações SMTP",
          tabTemplates: "Modelos de email",
          sectionTitle: "Configurações SMTP",
          newConfig: "Nova configuração",
          emptyList: "Sem configurações SMTP. Crie uma para começar.",
          colName: "Nome",
          colProvider: "Fornecedor",
          colHost: "Host",
          colPort: "Porta",
          colUser: "Utilizador",
          colStatus: "Estado",
          colActions: "Ações",
          defaultChip: "Predefinido",
          statusActive: "Ativo",
          statusInactive: "Inativo",
          tooltipTest: "Testar ligação",
          tooltipEdit: "Editar",
          tooltipDelete: "Eliminar",
          dialogNew: "Nova configuração SMTP",
          dialogEdit: "Editar configuração SMTP",
          fieldName: "Nome",
          fieldProvider: "Fornecedor",
          providerCustom: "Personalizado",
          fieldDescription: "Descrição",
          fieldHost: "Host SMTP",
          fieldPort: "Porta",
          fieldUser: "Utilizador / email",
          fieldPassword: "Palavra-passe",
          passwordKeepHint: "Vazio para manter a atual",
          gmailTooltipTitle: "Informação Gmail",
          gmailTooltipBody: "No Gmail use palavra-passe de aplicação, não a palavra-passe normal.",
          gmailTooltipSteps: "Passos:",
          gmailTooltipStep1: "1. Google → Segurança",
          gmailTooltipStep2: "2. Ative verificação em duas etapas",
          gmailTooltipStep3: "3. «Palavras-passe de aplicações»",
          gmailTooltipStep4: "4. Gerar para «Correio»",
          gmailTooltipStep5: "5. Use a palavra-passe de 16 caracteres aqui",
          gmailGuideLink: "Guia completo",
          fieldFrom: "Remetente (From)",
          sslLabel: "SSL (porta 465)",
          tlsLabel: "Exigir TLS (porta 587)",
          activeLabel: "Ativa",
          defaultLabel: "Predefinida",
          cancel: "Cancelar",
          save: "Guardar",
          testDialogTitle: "Testar ligação SMTP",
          testSuccess: "Ligação OK",
          testError: "Erro de ligação",
          deleteConfirm: "Eliminar esta configuração?",
          providerGmail: "Gmail",
          providerOutlook: "Outlook",
          fieldFromPlaceholder: "Nome <email@dominio.com>",
          testTitleSuccess: "Teste de ligação bem-sucedido",
          testTitleFail: "Falha no teste de ligação",
          testTitlePending: "A testar ligação SMTP…",
          testVerifying: "A verificar ligação ao servidor SMTP…",
          alertOkTitle: "Ligação OK",
          alertOkBody: "A configuração SMTP ligou-se ao servidor com sucesso.",
          alertErrTitle: "Erro de ligação",
          alertErrBody: "Não foi possível ligar ao servidor SMTP.",
          errorDetailsLabel: "Detalhes do erro:",
          close: "Fechar",
          suggestedFixTitle: "Sugestão:",
          suggestedFixBody:
            "Se usar Gmail, utilize palavra-passe de aplicação em vez da palavra-passe normal.",
        },
        vpsAlerts: {
          validation: {
            smtpSelect:
              "SMTP: escolha uma conta em «Configuração SMTP *» (não deixe «Seleccionar SMTP…»).",
            adminEmailRequired: "Email do administrador: obrigatório quando usa correio.",
            adminEmailInvalid: "Email do administrador: formato inválido.",
            whatsappSelect:
              "WhatsApp: escolha uma linha em «Ligação WhatsApp *» (vazio impede guardar).",
            adminWhatsappRequired:
              "Número WhatsApp do administrador: obrigatório quando usa WhatsApp.",
            adminWhatsappInvalid: "Número WhatsApp: use 10 a 15 dígitos; pode prefixar +.",
            whatsappTemplateRequired: "Modelo de mensagem WhatsApp: não pode estar vazio.",
          },
          validationModal: {
            bodyIntro: "O pedido não foi enviado. Complete o seguinte:",
            titleTest: "Faltam dados para o teste",
            titleSave: "Não é possível guardar: formulário incompleto",
          },
          notes: {
            noActiveSmtpTest:
              "Nota: não há contas SMTP activas. Configure uma no separador «SMTP».",
            noActiveSmtpSave:
              "Nota: não há contas SMTP activas. Crie ou active uma no separador «SMTP».",
            noConnectedWhatsapp: "Nota: não há WhatsApp em estado LIGADO; veja «Conexões».",
          },
          test: {
            lineEmailOk: "✅ Email enviado com sucesso",
            lineWhatsappOk: "✅ WhatsApp enviado com sucesso",
            successIntro: "Notificação de teste enviada com sucesso:",
            footerEmail: "Verifique o email para confirmar a recepção.",
            footerWhatsapp: "Verifique o WhatsApp para confirmar a recepção.",
            footerBoth: "Verifique o email e o WhatsApp para confirmar a recepção.",
            errorIntro: "Erro ao enviar notificação de teste:",
            unknownError: "Erro desconhecido",
          },
          save: {
            notSavedTitle: "A configuração não foi guardada",
            notSavedBody:
              "Veja a mensagem de erro no ecrã (se existir) e a sua ligação. Se persistir, tente novamente.",
            successTitle: "✅ Configuração guardada",
            successBody: "A configuração de notificações VPS foi guardada com sucesso.",
            errorTitle: "❌ Erro ao guardar",
            errorBody: "Erro ao guardar a configuração: {{message}}",
          },
          loadError:
            "Não foi possível carregar a configuração de alertas VPS: {{error}}. Confirme que o utilizador é administrador, a API está disponível e existem os objectos de BD (VPSNotificationConfig, SP).",
          retry: "Tentar novamente",
          generalSection: "Habilitação geral",
          toggleLabel: "Activar sistema de alertas e limpeza automática",
          infoWhyTitle: "Porquê activar este sistema?",
          infoIntro: "Este sistema de alertas e limpeza automática é especialmente útil se:",
          infoLi1: "O seu negócio gere milhares de mensagens WhatsApp por dia",
          infoLi2: "Gera muitos registos na base de dados",
          infoLi3: "Precisa de monitorização proactiva do servidor",
          infoLi4: "Quer prevenir discos cheios",
          infoClosing:
            "Se o negócio é pequeno e gera poucos registos, pode manter o sistema desactivado.",
          warningEnabled:
            "IMPORTANTE: Uma vez activo, receberá alertas automáticos quando o sistema detetar problemas. Configure correctamente email ou WhatsApp.",
          notificationsSection: "Configuração de notificações",
          channelEmail: "Email",
          channelWhatsapp: "WhatsApp",
          channelBoth: "Ambos",
          emailSection: "Configuração de email",
          smtpRequiredLabel: "Configuração SMTP *",
          selectSmtp: "Seleccionar SMTP...",
          emailTemplateOptional: "Modelo de email (opcional)",
          useDefaultTemplates: "Usar modelos por defeito",
          adminEmailLabel: "Email do administrador *",
          invalidEmail: "Formato de email inválido",
          adminEmailHint: "Email onde receberá os alertas",
          whatsappSection: "Configuração WhatsApp",
          whatsappConnectionLabel: "Ligação WhatsApp *",
          selectWhatsapp: "Seleccionar WhatsApp...",
          whatsappTemplateLabel: "Modelo de mensagem WhatsApp",
          whatsappTemplateVars:
            "Variáveis: {alertType}, {diskUsage}, {binaryLogsSize}, {cpuUsage}, {memoryUsage}, {message}, {subject}",
          adminWhatsappLabel: "Número WhatsApp do administrador *",
          invalidWhatsapp: "Formato inválido (10-15 dígitos, opcionalmente com +)",
          adminWhatsappHint: "Número onde receberá os alertas (com indicativo)",
          thresholdsSection: "Umbrais de alertas",
          diskPct: "Disco (%)",
          diskHelp: "Alerta quando o uso do disco ultrapassar esta percentagem",
          binaryGb: "Binary logs (GB)",
          binaryHelp: "Alerta quando o tamanho dos binary logs ultrapassar este valor",
          cpuPct: "CPU (%)",
          cpuHelp: "Alerta quando o uso de CPU ultrapassar esta percentagem",
          memPct: "Memória (%)",
          memHelp: "Alerta quando o uso de memória ultrapassar esta percentagem",
          enableDisk: "Activar alertas de disco",
          enableBinary: "Activar alertas de binary logs",
          enableCpu: "Activar alertas de CPU",
          enableMem: "Activar alertas de memória",
          enableCritical: "Activar alertas críticas",
          frequencySection: "Frequência de notificações e limpeza automática",
          alertFreqLabel: "Frequência de alertas (horas)",
          alertFreqHelp: "De quantas em quantas horas são enviados alertas (1-48)",
          cleanupSubtitle: "Limpeza automática do servidor",
          cleanupInfoTitle: "O que faz esta secção",
          cleanupInfoIntro:
            "Com a limpeza activa, o sistema pode executar manutenção sem intervenção manual:",
          cleanupInfoLi1:
            "Se o disco ultrapassar o limite (%): rotina completa (purga de binary logs conforme política do servidor, passos iterativos, optimização de tabelas críticas).",
          cleanupInfoLi2:
            "Se o disco estiver abaixo do limite mas os binary logs MySQL ultrapassarem o limite (GB): purga progressiva de logs.",
          cleanupRisk:
            "Risco operacional: a purga de binary logs afecta recuperação point-in-time (PITR). Use limites alinhados com backups e réplicas MySQL.",
          enableAutoCleanup: "Activar limpeza automática",
          cleanupCooldownNote:
            "A frequência de alertas ({{hours}} h) também limita repetições da limpeza disparada só por binary logs (GB) (cooldown desde a última execução desse tipo).",
          cleanupDiskThreshold: "Limite de disco para limpeza (%)",
          cleanupDiskHelp:
            "Se o uso do disco atingir este %, corre a rotina completa de limpeza (binlogs + passos adicionais conforme BD).",
          cleanupBinlogGb: "Limite de binary logs para limpeza (GB)",
          cleanupBinlogHelp:
            "Se o tamanho estimado de binary logs ≥ este valor e o disco não disparou a rotina anterior, purga progressiva. Normalmente menor que o limite só de alerta (GB).",
          lastCleanup: "Última limpeza automática (limite binary logs): {{date}}",
          saveConfig: "Guardar configuração",
          saving: "A guardar...",
          sendTest: "Enviar notificação de teste",
          sending: "A enviar...",
          testModal: {
            sending: "A enviar notificação de teste...",
            success: "✅ Notificação enviada",
            error: "❌ Erro ao enviar",
            pleaseWait: "Aguarde enquanto a notificação é enviada...",
            tipPrefix: "Dica:",
            tipEmail: "Verifique o email para confirmar a recepção.",
            tipWhatsapp: "Verifique o WhatsApp para confirmar a recepção.",
            tipBoth: "Verifique o email e o WhatsApp para confirmar a recepção.",
            close: "Fechar",
            cancel: "Cancelar",
          },
          accept: "Aceitar",
          defaultWhatsAppTemplate:
            "⚠️ ALERTA VPS: {alertType}\n📊 Estado do sistema:\n💾 Disco: {diskUsage}%\n📝 Binary logs: {binaryLogsSize} GB\n⚡ CPU: {cpuUsage}%\n🧠 Memória: {memoryUsage}%\n\n{message}",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed: "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        mediaCaptionPlaceholder: "Adicione uma mensagem… (opcional — enviada com o arquivo)",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        dragDrop: {
          sectionTitle: "Lista de arquivos",
          main: "Arraste e solte seus arquivos aqui",
          sub: "ou clique para selecionar arquivos",
          formats: "Formatos suportados: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, PNG, MP4, MP3",
        },
        table: {
          thumbnail: "Miniatura",
          name: "Nome",
          format: "Formato",
          size: "Peso",
          type: "Tipo",
          actions: "Ações",
        },
        validation: {
          nameMin: "Nome muito curto",
          required: "Obrigatório",
        },
        fileSize: { bytes: "Bytes", kb: "KB", mb: "MB", gb: "GB" },
        tooltips: { removeFile: "Excluir arquivo" },
        success: "Lista de arquivos salva com sucesso!",
      },
      financial: {
        title: "Financeiro",
        pageTitle: "Financeiro e assinaturas",
        tabs: {
          subscriptions: "Assinaturas",
          invoices: "Faturas",
          management: "Gestão",
        },
        table: {
          id: "ID",
          details: "Detalhes",
          value: "Valor",
          dueDate: "Vencimento",
          status: "Status",
          action: "Ação",
        },
        status: {
          paid: "Pago",
          overdue: "Vencido",
          open: "Em aberto",
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGO",
        },
        messages: {
          noInvoices: "Não há faturas para exibir",
          paymentSuccess: "Pagamento processado com sucesso",
          paymentError: "Erro ao processar o pagamento",
        },
        subscription: {
          currentPlanLabel: "Plano atual",
          noPlanAssigned: "Nenhum plano atribuído",
          availablePlans: "Planos disponíveis",
          availablePlansHint:
            "Escolha um plano para assinar. Você verá os métodos de pagamento disponíveis (Binance Pay, PayPal, Stripe ou pagamento manual).",
          perMonth: "/mês",
          users_one: "{{count}} usuário",
          users_other: "{{count}} usuários",
          connections_one: "{{count}} conexão WhatsApp",
          connections_other: "{{count}} conexões WhatsApp",
          queues_one: "{{count}} fila",
          queues_other: "{{count}} filas",
          featureCampaigns: "Campanhas",
          featureSchedules: "Agendamentos",
          featureOpenAi: "Inteligência artificial",
          subscribe: "Assinar",
          processing: "Processando…",
          noPlansTitle: "Nenhum plano disponível",
          noPlansHint: "Fale com o administrador para mais informações",
          manualPaymentTitle: "Pagamento manual disponível",
          manualPaymentHint:
            "Você pode escolher um plano e falar com o administrador para coordenar o pagamento.",
          manualPaymentEmail: "Email",
          binanceTitle: "Cobrança Binance Pay",
          binanceExact: "Pague exatamente este valor em USDT",
          binanceHint: "O sistema verifica o pagamento a cada minuto. Você também pode colar o Order ID.",
          binanceOrderId: "Order ID / Transaction ID",
          binanceOrderHint: "Opcional se a detecção automática não chegar.",
          binanceConfirm: "Confirmar Order ID",
          binanceRefresh: "Atualizar",
          binancePaid: "Pagamento confirmado",
          binanceCopy: "Copiar",
          binanceCopied: "Copiado",
          binanceCopyFail: "Não foi possível copiar",
          binanceStepsTitle: "Como pagar",
          binanceStep1: "Abra o app da Binance e entre em Pay → Enviar.",
          binanceStep2: "Envie exatamente {{amount}} USDT para o Pay ID {{payId}}.",
          binanceStep3: "Não arredonde: os centavos identificam seu pagamento.",
          binanceStep4: "Pronto: detectamos automaticamente. Se demorar, cole aqui o Order ID da Binance.",
          binanceWhatsappAlt: "Prefere WhatsApp? Envie PAGAR PLAN para",
          manualDefault: "Entre em contato com o administrador para combinar o pagamento manual do seu plano.",
          manualConfigHint: "Configure email, WhatsApp ou instruções em Configurações > Assinaturas.",
          manualTitle: "Pagamento manual",
          pageTitle: "Assinatura",
          trialLabel: "Período de teste",
          trialEnds: "Seu período de teste termina em {{days}} dias!",
          billingEmail: "Email de cobrança",
          subscribeNow: "Assine agora!",
          selectedPlan: "Plano selecionado",
          value: "Valor",
          close: "Fechar",
        },
        checkout: {
          title: "Falta pouco!",
          steps: { data: "Dados", customize: "Personalizar", review: "Revisar" },
          back: "VOLTAR",
          next: "PRÓXIMO",
          pay: "PAGAR",
          success: "Assinatura criada! Aguardando a confirmação do pagamento.",
          notFound: "Não encontrado",
          users: "{{count}} usuários",
          connections: "{{count}} conexões",
          queues: "{{count}} filas",
          select: "SELECIONAR",
          perMonth: "/mês",
          summary: "Resumo da assinatura",
          planDetails: "Detalhes do plano",
          usersLabel: "Usuários",
          billing: "Cobrança: Mensal",
          paymentInfo: "Informação de pagamento",
          name: "Nome",
          address: "Endereço",
          copied: "Copiado",
          copyQr: "Copiar código QR",
          pixHint: "Para finalizar, basta realizar o pagamento escaneando ou colando o código acima.",
          renewed: "Sua licença foi renovada até {{date}}!",
          addressIntro: "Vamos precisar de algumas informações",
          fullName: "Nome completo*",
          fullNameRequired: "O nome completo é obrigatório",
          street: "Endereço*",
          streetRequired: "O endereço é obrigatório",
          city: "Cidade*",
          cityRequired: "A cidade é obrigatória",
          state: "Estado*",
          stateRequired: "O estado é obrigatório",
          zip: "CEP*",
          zipRequired: "O CEP é obrigatório",
          zipInvalid: "Formato de CEP inválido",
          country: "País*",
          countryRequired: "O país é obrigatório",
          countries: { BR: "Brasil", CO: "Colômbia", US: "Estados Unidos" },
        },
      },
      kanban: {
        open: "Em aberto",
        tagNotFound: "Etiqueta não encontrada.",
        cannotMapStatus: "Não é possível mapear a coluna ao status da consulta.",
        appointmentUpdated: "Consulta atualizada.",
        ticketMoved: "Ticket movido com sucesso.",
        moveError: "Erro ao mover o card.",
        configureAgendaHint: "O quadro usa tags Kanban. Ative a Agenda nas configurações para colunas por perfil.",
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        openInNewWindow: "Abrir conversa em popup",
        openInNewUnavailable: "Este tíquete não tem UUID; não é possível abrir em outra aba.",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        appointmentsModal: {
          title: "Observações do Contato",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket",
          titleFrom: "do contato ",
          message: "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar Mensagem",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        react: "Reagir",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_COMPANY_INVALID_DUE_DATE: "A data de vencimento da empresa é inválida.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND: "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS: "Erro de autenticação. Por favor, tente novamente.",
        ERR_COMPANY_EXPIRED:
          "O período de teste ou o plano terminou. Escolha um plano e conclua o pagamento para voltar a usar o sistema.",
        COMPANY_EXPIRED_BANNER:
          "Seu período de teste ou plano terminou. Escolha um plano e conclua o pagamento para reativar o acesso. As conexões de WhatsApp e o histórico são removidos ao vencer.",
        COMPANY_EXPIRED_MENU:
          "O restante do sistema fica restrito até o plano estar em dia.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED: "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG: "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta cor já está em uso, escolha outra.",
        ERR_QUEUE_NAME_ALREADY_EXISTS: "Este nome de departamento já existe, escolha outro.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_INTERNAL_SERVER: "Erro interno do servidor. Tente novamente ou contacte o suporte.",
        ERR_DB_VALIDATION: "Os dados não passaram na validação do banco de dados.",
        ERR_TICKET_UPDATE_FAILED: "Não foi possível atualizar o tíquete. Tente novamente.",
        ERR_SETTING_FOREIGN_COMPANY: "Não é possível alterar as configurações de outra empresa.",
        ERR_NO_WBOT_FOR_WHATSAPP:
          "Não há sessão WhatsApp ativa para a conexão {{whatsappId}}. Verifique a página de conexões.",
        ERR_UNKNOWN: "Ocorreu um erro inesperado.",
      },

      hardcodedElements: {
        atendimento: "ATENDIMENTOS",
        tarefas: "TAREFAS",
        gerencia: "GERÊNCIA",
        campanhas: "CAMPANHAS",
        listagem: "LISTAGEM",
        configuracoes: "CONFIGURAÇÕES",
        administracao: "ADMINISTRAÇÃO",
        semFila: "SEM FILA",
        sair: "SAIR",
        sayHelloToNewContact: "Olá! Como posso ajudá-lo?",
        admin: "ADMIN",
        filas: "FILAS",
        todos: "TODOS",
        hey: "hey",
      },
    },
  },
};

extendGettingStartedTranslations(messages.pt.translations, "pt");

export { messages };
